/* eslint-disable no-use-before-define */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /**
     * A date string, such as 2007-12-03, compliant with the `full-date` format
     * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
     * representation of dates and times using the Gregorian calendar.
     */
    Date: { input: any; output: any };
    /**
     * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
     * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
     * 8601 standard for representation of dates and times using the Gregorian calendar.
     */
    DateTime: { input: any; output: any };
    /** The `Decimal` scalar type to represent currency values */
    Decimal: { input: any; output: any };
    /** The "Int64" scalar type represents non-fractional whole numeric values between -9223372036854775808 and 9223372036854775807. */
    Int64: {
        input: Intl.StringNumericLiteral;
        output: Intl.StringNumericLiteral;
    };
    /** An IEFT BCF 47 Language tag as specified by RFC 3306 */
    LanguageTag: { input: any; output: any };
    /**
     * A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format
     * outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for
     * representation of dates and times using the Gregorian calendar.
     */
    Time: { input: any; output: any };
};

export type AcceptProjectSubscriptionTermsInput = {
    readonly acceptGeneralTermsAndConditions: Scalars['Boolean']['input'];
    readonly acceptProjectSubscriptionTermsAndConditions: Scalars['Boolean']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type AcceptProjectSubscriptionTermsPayload = {
    readonly __typename?: 'AcceptProjectSubscriptionTermsPayload';
    readonly project?: Maybe<Project>;
};

export type ActivateSurveyInput = {
    /**
     * Default: true; Set to false to deactivate the survey
     *
     * (probably we should instead have a deactivate survey mutation)
     */
    readonly activate?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * When you set this to true, the survey date/time will be changed to the current date and time before
     * the survey is activated
     *
     * Be careful not to set this to true if you want the survey to be sent later.
     */
    readonly sendRightAway?: InputMaybe<Scalars['Boolean']['input']>;
    readonly surveyId: Scalars['ID']['input'];
};

export type ActivateSurveyPayload = {
    readonly __typename?: 'ActivateSurveyPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type AddPortfolioInput = {
    readonly name: Scalars['String']['input'];
    /**
     * The organization main portfolio id can be used as parent id as well as any sub portfolio id.
     * The maximum levels of sub-portfolios is 3.
     */
    readonly parentPortfolioId: Scalars['ID']['input'];
};

export type AddPortfolioPayload = {
    readonly __typename?: 'AddPortfolioPayload';
    readonly mainPortfolio?: Maybe<MainPortfolio>;
    /** The added portfolio */
    readonly portfolio?: Maybe<SubPortfolio>;
    readonly team?: Maybe<Team>;
};

export type AddProjectCategoryInput = {
    readonly description?: InputMaybe<Scalars['String']['input']>;
    readonly name: Scalars['String']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type AddProjectCategoryPayload = {
    readonly __typename?: 'AddProjectCategoryPayload';
    /** The added project template */
    readonly projectCategory?: Maybe<ProjectCategory>;
    /**
     * Project templates are added on the team/organization, so it is a good idea to query the team with the
     * new updated list of project templates
     */
    readonly team?: Maybe<Team>;
};

export type AddProjectSurveyInput = {
    /** If omitted, a default of 10 weekdays will be used as survey length (usually ends up being 14 days) */
    readonly endDate?: InputMaybe<Scalars['Date']['input']>;
    readonly projectId: Scalars['ID']['input'];
    /**
     * Optionally provide some default survey meta question responses for the recipient list that will be
     * created for this project survey
     */
    readonly recipientListSurveyMeta?: InputMaybe<
        ReadonlyArray<ProjectSurveyRecipientListSurveyMetaInput>
    >;
    readonly surveyDate: Scalars['Date']['input'];
    readonly surveyNumber: Scalars['Int']['input'];
    /**
     * Optionally specify the time of the day when the survey should be sent.
     *
     * * Uses the timezone of the project.
     * * If not specified, the default time is 08:00
     * * Use the format hh:mm (24 hours)
     */
    readonly timeOfDay?: InputMaybe<Scalars['String']['input']>;
};

export type AddProjectSurveyPayload = {
    readonly __typename?: 'AddProjectSurveyPayload';
    readonly project?: Maybe<Project>;
    readonly survey?: Maybe<ProjectSurvey>;
};

export type AddProjectSurveyTemplateInput = {
    readonly description: Scalars['String']['input'];
    readonly name: Scalars['String']['input'];
    readonly questionFilters: ReadonlyArray<ProjectSurveyTemplateQuestionFilterInput>;
    readonly questionIds: ReadonlyArray<Scalars['String']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type AddQuestionInput = {
    /** The full form of the question will be asked to the respondent */
    readonly fullForm: Scalars['String']['input'];
    /** Should it be possible for the respondent to write a comment to the response */
    readonly hasCommentField?: InputMaybe<Scalars['Boolean']['input']>;
    /** Should an extra question: 'Does it need improvement? Yes/No' be used */
    readonly hasImproveQuestion?: InputMaybe<Scalars['Boolean']['input']>;
    /** Should it be possible for the respondent to not have an opinion */
    readonly hasNoOpinion?: InputMaybe<Scalars['Boolean']['input']>;
    /** You may optionally specify that the question you add should be a draft question. */
    readonly isDraft?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Is the question to be used as respondent meta (Information about the respondent), meaning that the responses"
     * can be used to filter results
     */
    readonly isMeta?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Is the question to be used as survey meta (Information about the survey), meaning that the responses
     * can be used to filter results
     */
    readonly isSurveyMeta?: InputMaybe<Scalars['Boolean']['input']>;
    /** Locale for the question short form and full form */
    readonly locale: Scalars['LanguageTag']['input'];
    /** Optionally specify a path that can be used in URL's */
    readonly path?: InputMaybe<Scalars['String']['input']>;
    /**
     * Optionally specify an id for the question
     * (should be a UUID, but will be converted to a relay compatible ID when fetching the question)
     */
    readonly questionId?: InputMaybe<Scalars['ID']['input']>;
    readonly questionType: QuestionType;
    /** Add the question to this questionnaire */
    readonly questionnaireId: Scalars['ID']['input'];
    /** Which response scale should be used? Contains the different response options */
    readonly responseScaleId?: InputMaybe<Scalars['ID']['input']>;
    /** The short form of the question may be used in reports and charts */
    readonly shortForm?: InputMaybe<Scalars['String']['input']>;
};

export type AddQuestionPayload = {
    readonly __typename?: 'AddQuestionPayload';
    readonly question?: Maybe<Question>;
    /** The questionnaire is returned alongside the question, for the locale that the question was added in */
    readonly questionnaire?: Maybe<Questionnaire>;
};

export type AddQuestionToIndicatorInput = {
    readonly indicatorId: Scalars['ID']['input'];
    /** Even though no localized attributes are updated, we need the locale to be able to return the indicator */
    readonly locale: Scalars['LanguageTag']['input'];
    readonly questionId: Scalars['ID']['input'];
};

export type AddQuestionToIndicatorPayload = {
    readonly __typename?: 'AddQuestionToIndicatorPayload';
    readonly indicator?: Maybe<Indicator>;
};

export type AddQuestionToSectionInput = {
    readonly locale?: InputMaybe<Scalars['LanguageTag']['input']>;
    readonly questionId: Scalars['ID']['input'];
    readonly questionnaireId: Scalars['ID']['input'];
    readonly sectionId: Scalars['ID']['input'];
};

export type AddQuestionToSectionPayload = {
    readonly __typename?: 'AddQuestionToSectionPayload';
    readonly section?: Maybe<Section>;
};

export type AddRecipientInput = {
    readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
    readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
    readonly preRegisteredMetaQuestionResponses?: InputMaybe<
        ReadonlyArray<QuestionResponseInput>
    >;
    readonly recipientType: RecipientType;
};

export type AddRecipientToListInput = {
    readonly recipient?: InputMaybe<AddRecipientInput>;
    readonly recipientListId: Scalars['ID']['input'];
};

export type AddRecipientToListPayload = {
    readonly __typename?: 'AddRecipientToListPayload';
    readonly respondent: Respondent;
};

export type AddRecipientsToListInput = {
    /** Deprecated! Use recipients prop instead */
    readonly emailAddresses?: InputMaybe<
        ReadonlyArray<Scalars['String']['input']>
    >;
    /** Deprecated! Use recipients prop instead */
    readonly phoneNumbers?: InputMaybe<
        ReadonlyArray<Scalars['String']['input']>
    >;
    readonly recipientListId: Scalars['ID']['input'];
    readonly recipients?: InputMaybe<ReadonlyArray<AddRecipientInput>>;
};

export type AddRecipientsToListPayload = {
    readonly __typename?: 'AddRecipientsToListPayload';
    readonly recipientList?: Maybe<RecipientList>;
    readonly recipients: ReadonlyArray<Recipient>;
};

export type AddRespondentFromSurveyCodeInput = {
    /** If not specified, the new respondent will use the default locale defined in the recipient list */
    readonly locale?: InputMaybe<Scalars['LanguageTag']['input']>;
    readonly recipientType: RecipientType;
    readonly surveyCode: Scalars['String']['input'];
};

export type AddRespondentFromSurveyCodePayload = {
    readonly __typename?: 'AddRespondentFromSurveyCodePayload';
    readonly respondent?: Maybe<Respondent>;
    /**
     * If we dont get a respondent back, it is likely that the survey is closed
     * or the recipient list deleted.
     */
    readonly surveyStatus?: Maybe<RecipientListStatus>;
};

export type AddVisibilityConditionInput = {
    readonly assignments?: InputMaybe<
        ReadonlyArray<VisibilityConditionAssignmentInput>
    >;
    /**
     * Optionally give the visibility condition a name. This is to be able to
     * identify this condition if you are using it with multiple questions
     */
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly questionnaireId: Scalars['ID']['input'];
    readonly visibilityCondition: VisibilityConditionInput;
};

export type AddVisibilityConditionPayload = {
    readonly __typename?: 'AddVisibilityConditionPayload';
    readonly questionnaire?: Maybe<Questionnaire>;
    readonly visibilityCondition?: Maybe<VisibilityCondition>;
};

export type AddVisibilityConditionPayloadQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type AggregatedDataSheet = {
    readonly __typename?: 'AggregatedDataSheet';
    /** Results by indicator, optionally filtered */
    readonly indicatorResults: ReadonlyArray<DataSheetIndicatorResult>;
    /** Results by question, optionally filtered */
    readonly questionResults: ReadonlyArray<DataSheetQuestionResult>;
    /** Number of aggregated project surveys */
    readonly surveyCount: Scalars['Int']['output'];
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type AggregatedDataSheetIndicatorResultsArgs = {
    indicatorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type AggregatedDataSheetQuestionResultsArgs = {
    questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaire = QuestionnaireInterface & {
    readonly __typename?: 'AggregatedQuestionnaire';
    readonly ancestors: ReadonlyArray<Questionnaire>;
    readonly availableLocales: ReadonlyArray<Scalars['LanguageTag']['output']>;
    /** @deprecated Use the tools available in your programming language */
    readonly availableLocalesInfo: ReadonlyArray<LocaleInfo>;
    readonly id: Scalars['ID']['output'];
    readonly indicators: ReadonlyArray<Indicator>;
    readonly locale: Scalars['LanguageTag']['output'];
    /** @deprecated Use the tools available in your programming language */
    readonly localeInfo: LocaleInfo;
    readonly name?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use rawId */
    readonly originalId: Scalars['String']['output'];
    readonly questions: ReadonlyArray<Question>;
    readonly rawId: Scalars['String']['output'];
    /** The reference data included here is for the root questionnaire */
    readonly referenceData?: Maybe<QuestionnaireReferenceData>;
    readonly responseScales: ReadonlyArray<ResponseScale>;
    readonly sections: ReadonlyArray<Section>;
    readonly standardTexts: ReadonlyArray<StandardText>;
    readonly textReplacements: ReadonlyArray<TextReplacement>;
    readonly version: Scalars['Int']['output'];
    readonly visibilityConditions: ReadonlyArray<VisibilityCondition>;
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaireAvailableLocalesInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaireLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaireQuestionsArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaireReferenceDataArgs = {
    name: Scalars['String']['input'];
};

/**
 * A questionnaire with all its parents aggregated/combined.
 *
 * * Contains all questions from the child and all its parents
 * * Contains all sections from the child and all its parents
 * * Contains all response scales from the child and all its parents
 * * Contains all text replacements from the child and all its parents
 * * Contains all standard texts from the child and all its parents
 * * Contains all indicators from the child and all its parents
 * * Attributes such as name, instructions etc, is overridden by the last child questionnaire
 */
export type AggregatedQuestionnaireStandardTextsArgs = {
    prefix?: InputMaybe<Scalars['String']['input']>;
    types?: InputMaybe<ReadonlyArray<StandardTextType>>;
};

export type AreaOfImprovement = {
    readonly __typename?: 'AreaOfImprovement';
    readonly activities: ReadonlyArray<Maybe<ImprovementActivity>>;
    readonly areaOfImprovementId: Scalars['String']['output'];
    /**
     * The user who created this area of improvement. If empty, it can mean two
     * things. Either the user has been removed, or the area of improvement was
     * created by a service
     */
    readonly createdBy?: Maybe<User>;
    readonly createdOn: Scalars['DateTime']['output'];
    readonly id: Scalars['ID']['output'];
    readonly problemDescription?: Maybe<Scalars['String']['output']>;
    /** Url friendly version of the summary */
    readonly slug: Scalars['String']['output'];
    readonly summary: Scalars['String']['output'];
    readonly tags: ReadonlyArray<AreaOfImprovementTag>;
};

export type AreaOfImprovementIndicatorTag = {
    readonly __typename?: 'AreaOfImprovementIndicatorTag';
    readonly indicatorKey: Scalars['String']['output'];
    readonly questionnaireId: Scalars['ID']['output'];
};

export type AreaOfImprovementIndicatorTagInput = {
    readonly indicatorKey: Scalars['String']['input'];
    readonly questionnaireId: Scalars['ID']['input'];
};

export type AreaOfImprovementQuestionTag = {
    readonly __typename?: 'AreaOfImprovementQuestionTag';
    readonly questionId: Scalars['ID']['output'];
};

export type AreaOfImprovementQuestionTagInput = {
    readonly questionId: Scalars['ID']['input'];
};

export type AreaOfImprovementResponseOptionTag = {
    readonly __typename?: 'AreaOfImprovementResponseOptionTag';
    readonly questionId: Scalars['ID']['output'];
    readonly responseOptionValue: Scalars['Int']['output'];
};

export type AreaOfImprovementResponseOptionTagInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly responseOptionValue: Scalars['Int']['input'];
};

export type AreaOfImprovementTag =
    | AreaOfImprovementIndicatorTag
    | AreaOfImprovementQuestionTag
    | AreaOfImprovementResponseOptionTag;

/** Since graphql does not support unions or interfaces in mutations, we can use a type where you populate one of the fields */
export type AreaOfImprovementTagUnionInput = {
    readonly Indicator?: InputMaybe<AreaOfImprovementIndicatorTagInput>;
    readonly Question?: InputMaybe<AreaOfImprovementQuestionTagInput>;
    readonly ResponseOption?: InputMaybe<AreaOfImprovementResponseOptionTagInput>;
};

export type AssignProjectCategoryInput = {
    readonly projectCategoryId: Scalars['ID']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type AssignProjectCategoryPayload = {
    readonly __typename?: 'AssignProjectCategoryPayload';
    readonly project?: Maybe<ProjectInterface>;
};

export type AssignProjectManagerInput = {
    readonly email: Scalars['String']['input'];
    readonly firstName?: InputMaybe<Scalars['String']['input']>;
    readonly lastName?: InputMaybe<Scalars['String']['input']>;
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly projectId: Scalars['ID']['input'];
};

export type AssignProjectManagerPayload = {
    readonly __typename?: 'AssignProjectManagerPayload';
    readonly project?: Maybe<ProjectInterface>;
};

export type AssignProjectSurveyPlannerInput = {
    readonly email: Scalars['String']['input'];
    readonly firstName?: InputMaybe<Scalars['String']['input']>;
    readonly lastName?: InputMaybe<Scalars['String']['input']>;
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly projectId: Scalars['ID']['input'];
};

export type AssignProjectSurveyPlannerPayload = {
    readonly __typename?: 'AssignProjectSurveyPlannerPayload';
    readonly project?: Maybe<Project>;
};

export type AssignProjectSurveySenderInput = {
    readonly email: Scalars['String']['input'];
    readonly firstName?: InputMaybe<Scalars['String']['input']>;
    readonly lastName?: InputMaybe<Scalars['String']['input']>;
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly projectId: Scalars['ID']['input'];
};

export type AssignProjectSurveySenderPayload = {
    readonly __typename?: 'AssignProjectSurveySenderPayload';
    readonly project?: Maybe<Project>;
};

export type AssignTeamContactPersonsInput = {
    readonly mainContactAtBinosight?: InputMaybe<TeamContactPersonInput>;
    readonly mainContactAtCustomer?: InputMaybe<TeamContactPersonInput>;
    readonly teamId: Scalars['ID']['input'];
};

export type AssignTeamContactPersonsPayload = {
    readonly __typename?: 'AssignTeamContactPersonsPayload';
    readonly team?: Maybe<Team>;
};

export type AssignTeamIndustryConnectionsInput = {
    readonly connections: ReadonlyArray<Scalars['String']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type AssignTeamIndustryConnectionsPayload = {
    readonly __typename?: 'AssignTeamIndustryConnectionsPayload';
    readonly team?: Maybe<Team>;
};

export type AssignVisibilityConditionToQuestionInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly visibilityConditionId: Scalars['ID']['input'];
};

export type BasicVisibilityCondition = VisibilityConditionInterface & {
    readonly __typename?: 'BasicVisibilityCondition';
    readonly expression: Scalars['String']['output'];
    readonly rules: ReadonlyArray<VisibilityConditionRule>;
};

export type BestPractice = {
    readonly P10: Scalars['Float']['output'];
    readonly P25: Scalars['Float']['output'];
    readonly P75: Scalars['Float']['output'];
    readonly P90: Scalars['Float']['output'];
};

export type BudgetTieredPricingBreakpointInput = {
    readonly bindingPeriod: Scalars['Int']['input'];
    readonly discountPercent: Scalars['Int']['input'];
    readonly displayedMinBudget?: InputMaybe<Scalars['Decimal']['input']>;
    readonly minBudget: Scalars['Decimal']['input'];
    readonly monthlyCost: Scalars['Decimal']['input'];
    readonly noticePeriod: Scalars['Int']['input'];
};

export type BudgetTieredPricingPriceListInput = {
    readonly breakpoints: ReadonlyArray<BudgetTieredPricingBreakpointInput>;
    readonly currency: Scalars['String']['input'];
    readonly displayedBudgetCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type BudgetYearlyProjectSurveysInput = {
    readonly surveyCount: Scalars['Int']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type BudgetYearlyProjectSurveysPayload = {
    readonly __typename?: 'BudgetYearlyProjectSurveysPayload';
    readonly team?: Maybe<Team>;
};

export type ChangeIndicatorQuestionsInput = {
    readonly indicatorId: Scalars['ID']['input'];
    /** Even though no localized attributes are updated, we need the locale to be able to return the indicator */
    readonly locale: Scalars['LanguageTag']['input'];
    readonly questionIds: ReadonlyArray<Scalars['ID']['input']>;
};

export type ChangeIndicatorQuestionsPayload = {
    readonly __typename?: 'ChangeIndicatorQuestionsPayload';
    readonly indicator?: Maybe<Indicator>;
};

export type ChangeProjectSurveyEndDateInput = {
    readonly date: Scalars['Date']['input'];
    readonly surveyId: Scalars['ID']['input'];
};

export type ChangeProjectSurveyEndDateResponse =
    | ChangeProjectSurveyEndDateSuccess
    | ProjectSurveyClosedError
    | ProjectSurveyEndsBeforeStartError
    | ProjectSurveyEndsBeforeTodayError;

export type ChangeProjectSurveyEndDateSuccess = {
    readonly __typename?: 'ChangeProjectSurveyEndDateSuccess';
    /** The updated survey */
    readonly survey: ProjectSurvey;
};

export type ChangeRecipientListLocaleInput = {
    readonly locale: Scalars['LanguageTag']['input'];
    readonly recipientListId: Scalars['ID']['input'];
};

export type ChangeRecipientListLocalePayload = {
    readonly __typename?: 'ChangeRecipientListLocalePayload';
    readonly recipientList?: Maybe<RecipientList>;
    readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangeRespondentLocaleInput = {
    readonly locale: Scalars['LanguageTag']['input'];
    readonly respondentId: Scalars['ID']['input'];
};

export type ChangeRespondentLocalePayload = {
    readonly __typename?: 'ChangeRespondentLocalePayload';
    readonly respondent?: Maybe<Respondent>;
};

export type ChangeSurveyDateInput = {
    readonly surveyDate: Scalars['Date']['input'];
    readonly surveyId: Scalars['ID']['input'];
};

export type ChangeSurveyDatePayload = {
    readonly __typename?: 'ChangeSurveyDatePayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type ChangeSurveyTemplateForProjectSurveyInput = {
    readonly surveyId: Scalars['ID']['input'];
    readonly surveyTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChangeSurveyTemplateForProjectSurveyPayload = {
    readonly __typename?: 'ChangeSurveyTemplateForProjectSurveyPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type ChangeSurveyTimeInput = {
    readonly surveyId: Scalars['ID']['input'];
    /** 24-hour time formatted as hh:ss, example: 08:30 */
    readonly timeOfDay: Scalars['String']['input'];
};

export type ChangeSurveyTimePayload = {
    readonly __typename?: 'ChangeSurveyTimePayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type ChangeTeamOrganizationNumberInput = {
    readonly organizationNumber: Scalars['String']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type ChangeTeamOrganizationNumberPayload = {
    readonly __typename?: 'ChangeTeamOrganizationNumberPayload';
    readonly team?: Maybe<Team>;
};

export type ChangeUserSettingsInput = {
    /** Preferred locale used for comminucation */
    readonly preferredLocale?: InputMaybe<Scalars['LanguageTag']['input']>;
    /**
     * Changes the user settings for this user. If omitted, will change the user settings of the
     * authenticated user
     */
    readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChangeUserSettingsPayload = {
    readonly __typename?: 'ChangeUserSettingsPayload';
    readonly userSettings?: Maybe<UserSettings>;
};

export type CloseSurveyInput = {
    readonly surveyId: Scalars['ID']['input'];
};

export type CloseSurveyPayload = {
    readonly __typename?: 'CloseSurveyPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type ConfirmPreliminaryProjectSurveyInput = {
    readonly projectId: Scalars['ID']['input'];
    /**
     * Optionally provide some default survey meta question responses for the recipient list that will be
     * created for this project survey
     */
    readonly recipientListSurveyMeta?: InputMaybe<
        ReadonlyArray<ProjectSurveyRecipientListSurveyMetaInput>
    >;
    /** Confirm the survey to be sent on this day */
    readonly surveyDate: Scalars['Date']['input'];
    readonly surveyNumber: Scalars['Int']['input'];
    /**
     * Optionally specify the time of the day when the survey should be sent.
     *
     * * Uses the timezone of the project.
     * * If not specified, the default time is 08:00
     * * Use the format hh:mm (24 hours)
     */
    readonly timeOfDay?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmPreliminaryProjectSurveyPayload = {
    readonly __typename?: 'ConfirmPreliminaryProjectSurveyPayload';
    readonly project?: Maybe<Project>;
    readonly survey?: Maybe<ProjectSurvey>;
};

export type CorrectMetaQuestionResponsePayload = {
    readonly __typename?: 'CorrectMetaQuestionResponsePayload';
    readonly questionResponse?: Maybe<QuestionResponse>;
    readonly updatedCaches?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAreaOfImprovementInput = {
    readonly improvementBankId: Scalars['ID']['input'];
    readonly problemDescription?: InputMaybe<Scalars['String']['input']>;
    readonly summary: Scalars['String']['input'];
    readonly tags: ReadonlyArray<AreaOfImprovementTagUnionInput>;
};

export type CreateAreaOfImprovementResponse = {
    readonly __typename?: 'CreateAreaOfImprovementResponse';
    readonly areaOfImprovement?: Maybe<AreaOfImprovement>;
    readonly improvementBank?: Maybe<ImprovementBank>;
};

export type CreateImprovementActivityInput = {
    readonly areaOfImprovementId: Scalars['ID']['input'];
    readonly deadline?: InputMaybe<Scalars['DateTime']['input']>;
    readonly description?: InputMaybe<Scalars['String']['input']>;
    readonly goal?: InputMaybe<Scalars['String']['input']>;
    readonly responsiblePerson: Scalars['ID']['input'];
    readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
    readonly summary: Scalars['String']['input'];
};

export type CreateImprovementActivityResponse = {
    readonly __typename?: 'CreateImprovementActivityResponse';
    readonly areaOfImprovement?: Maybe<AreaOfImprovement>;
    readonly improvementActivity?: Maybe<ImprovementActivity>;
};

export type CreateImprovementBankForProjectInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type CreateImprovementBankForProjectResponse = {
    readonly __typename?: 'CreateImprovementBankForProjectResponse';
    readonly project?: Maybe<Project>;
};

export type CreateProjectInput = {
    /** Official name of the project */
    readonly name: Scalars['String']['input'];
    /**
     * Optionally assign this project to a portfolio. If you pass in NULL, the project will
     * be added to the main portfolio. You may also use portfolioPath.
     *
     * **If you specify the portfolioId, you must not specify teamId or teamPath**
     */
    readonly portfolioId?: InputMaybe<Scalars['ID']['input']>;
    /** May be used instead of portfolioId */
    readonly portfolioPath?: InputMaybe<Scalars['String']['input']>;
    /**
     * The project will be added to this team.
     *
     * **If you specify portfolioId or teamPath, you must not specify teamId**
     */
    readonly teamId?: InputMaybe<Scalars['ID']['input']>;
    /** May be used instead of teamId */
    readonly teamPath?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectPayload = {
    readonly __typename?: 'CreateProjectPayload';
    readonly project?: Maybe<Project>;
};

export type CreateTeamInput = {
    readonly measuringModelId: Scalars['ID']['input'];
    readonly teamName: Scalars['String']['input'];
    readonly teamOwner?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTeamPayload = {
    readonly __typename?: 'CreateTeamPayload';
    readonly team?: Maybe<Team>;
};

/** Customize which questions that should be used for a survey */
export type CustomizeQuestionnaireInput = {
    /** Toggle disableQuestionComments */
    readonly disableQuestionComments?: InputMaybe<Scalars['Boolean']['input']>;
    /** This must be enabled for the questionnaire customization to be used */
    readonly enabled: Scalars['Boolean']['input'];
    /** Questions from these indicators will be used in this customized questionnaire */
    readonly indicatorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /** Use these questions in this customized questionnaire. */
    readonly questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /** Add custom visibility conditions */
    readonly questionVisibilityConditions?: InputMaybe<
        ReadonlyArray<QuestionVisibilityConditionInput>
    >;
    /** Identifies the recipient list that this customization should apply for */
    readonly recipientListId: Scalars['ID']['input'];
};

export type CustomizeQuestionnairePayload = {
    readonly __typename?: 'CustomizeQuestionnairePayload';
    /**
     * The recipient list will have an updated customizedQuestionnaire field, and
     * the questionnaire will also have the new config applied
     */
    readonly recipientList?: Maybe<RecipientList>;
};

/** Customized which questions that should be used for a survey */
export type CustomizedQuestionnaire = {
    readonly __typename?: 'CustomizedQuestionnaire';
    /**
     * Disable the possibility for the respondent to write comments. This
     * includes the custom improve question as well as regular comments
     * and open ended questions.
     */
    readonly disableQuestionComments?: Maybe<Scalars['Boolean']['output']>;
    /**
     * When enabled, fetching a questionnaire via a respondent will use this customization
     * Before you have run the customizedQuestionnaire mutation, the enabled field will be
     * null, indicating that a decision on this is not yet made.
     */
    readonly enabled?: Maybe<Scalars['Boolean']['output']>;
    /**
     * These indicators will be used for results. You may for instance pick a single question from
     * an indicator, but that might deem the indicator result useless, and in that case we want to
     * exclude that indicator in result calculation.
     *
     * @deprecated This is not used like in the description
     */
    readonly indicatorIds: ReadonlyArray<Scalars['ID']['output']>;
    readonly originalIndicatorIds: ReadonlyArray<Scalars['String']['output']>;
    readonly originalQuestionIds: ReadonlyArray<Scalars['String']['output']>;
    /** These questions will be used when answering a survey */
    readonly questionIds: ReadonlyArray<Scalars['ID']['output']>;
    readonly questionVisibilityConditions: ReadonlyArray<QuestionVisibilityCondition>;
};

export type DashboardSubscription = {
    readonly __typename?: 'DashboardSubscription';
    readonly endedAt?: Maybe<Scalars['Date']['output']>;
    readonly files?: Maybe<ReadonlyArray<File>>;
    readonly info?: Maybe<DashboardSubscriptionInfo>;
    readonly status: DashboardSubscriptionStatus;
};

export type DashboardSubscriptionInfo = {
    readonly __typename?: 'DashboardSubscriptionInfo';
    readonly activeFrom: Scalars['Date']['output'];
    readonly activeUntil: Scalars['Date']['output'];
    readonly monthlyCost: Money;
    readonly renewalPolicy: DashboardSubscriptionRenewalPolicy;
};

export type DashboardSubscriptionInput = {
    readonly activeFrom: Scalars['Date']['input'];
    readonly activeUntil: Scalars['Date']['input'];
    readonly monthlyCost: MoneyInput;
    readonly renewalPolicy: DashboardSubscriptionRenewalPolicyInput;
};

export type DashboardSubscriptionRenewalPolicy = {
    readonly __typename?: 'DashboardSubscriptionRenewalPolicy';
    readonly description: Scalars['String']['output'];
};

export type DashboardSubscriptionRenewalPolicyInput = {
    readonly description: Scalars['String']['input'];
};

export enum DashboardSubscriptionStatus {
    Active = 'ACTIVE',
    Ended = 'ENDED',
    NotStarted = 'NOT_STARTED',
}

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type DataSheet = {
    readonly __typename?: 'DataSheet';
    /** The total number of comments received on all questions from all respondents */
    readonly commentCount: Scalars['Int']['output'];
    /** The date that the survey closed */
    readonly endDate: Scalars['Date']['output'];
    /** Results by indicator, optionally filtered */
    readonly indicatorResults: ReadonlyArray<DataSheetIndicatorResult>;
    readonly projectBudget?: Maybe<Scalars['Int64']['output']>;
    /** Shortcut to Project.projectCategoryId */
    readonly projectCategoryId?: Maybe<Scalars['ID']['output']>;
    readonly projectId: Scalars['ID']['output'];
    /** Results by question, optionally filtered */
    readonly questionResults: ReadonlyArray<DataSheetQuestionResult>;
    /**
     * Number of respondents that excluded themselves from the survey using any of the provided options
     * to do so.
     */
    readonly removedSelfRespondentsCount: Scalars['Int']['output'];
    /**
     * The number of respondents that should answer the survey. Respondents that has excluded themselves as
     * not part of this project, or did not identify themselves with any of the questionnaires we are
     * offering are excluded.
     */
    readonly respondentCount: Scalars['Int']['output'];
    /**
     * Number or responses to this survey.
     * (This exludes respondents that has no opinion for all questions, so it is really equivalent to
     * answerCount)
     */
    readonly responseCount: Scalars['Int']['output'];
    /** Percentage (0-1) of responses to the survey (equal to responseCount / respondentCount) */
    readonly responseRate: Scalars['Float']['output'];
    /**
     * A list of results
     * @deprecated Use indicatorResults and questionResults
     */
    readonly results: ReadonlyArray<DataSheetResult>;
    /** The date that the survey opened */
    readonly surveyDate: Scalars['Date']['output'];
    /** The survey meta responses (project survey tags) */
    readonly surveyMeta: ReadonlyArray<DataSheetSurveyMeta>;
    readonly surveyNumber: Scalars['Int']['output'];
    readonly teamId: Scalars['ID']['output'];
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type DataSheetIndicatorResultsArgs = {
    indicatorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type DataSheetProjectBudgetArgs = {
    currency: DataSheetFilterProjectBudgetCurrency;
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type DataSheetQuestionResultsArgs = {
    questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type DataSheetFilterInput = {
    /** (internal) Are you fetching results to be displayed in the dashboard? This limits the number of returned projects */
    readonly _dashboard?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Should data sheets from ongoing surveys be included in the result? Right now, the
     * data sheets for ongoing surveys are updated once per hour.
     */
    readonly includeOngoingSurveys?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Only fetch results for the specified indicators (recommended, can be combined with questionIds)
     *
     * NOTE! Does not apply to data sheets meta groups. We might deprecate this and move this to another type
     *
     * @DEPRECATED - USE DataSheets.indicatorResults(indicatorIds: [...]) instead
     */
    readonly indicatorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /**
     * Limit the results to data sheets from your projects only. A project is considered "my project" if you are a member
     * of that project.
     */
    readonly onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Limit results to a specific portfolio. This can be used instead of the
     * teamId filter and should be the id of either the main portfolio or a sub portfolio.
     *
     * **When using portfolioId, the value for teamId is ignored**
     */
    readonly portfolioId?: InputMaybe<Scalars['ID']['input']>;
    /**
     * Limit results to a specific portfolio using the portfolio "path". The main
     * portfolio can be identified using an empty path: ''. The path is the url friendly
     * version of the portfolio name and not a hierarchy.
     */
    readonly portfolioPath?: InputMaybe<Scalars['String']['input']>;
    readonly projectBudget?: InputMaybe<DataSheetFilterProjectBudgetInput>;
    /** Only show results from projects that use the specified project category */
    readonly projectCategoryIds?: InputMaybe<
        ReadonlyArray<Scalars['ID']['input']>
    >;
    /** Limit results to one or many projects or specific surveys */
    readonly projectFilter?: InputMaybe<
        ReadonlyArray<DataSheetFilterProjectInput>
    >;
    /**
     * Only fetch results for the specified questions (recommended, can be combined with indicatorIds)
     *
     * NOTE! Does not apply to data sheets meta groups. We might deprecate this and move this to another type
     *
     * @DEPRECATED - USE DataSheets.questionResults(questionIds: [...]) instead
     */
    readonly questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /** Limit the results to respondents with the specified respondent meta responses */
    readonly respondentMetaFilter?: InputMaybe<
        ReadonlyArray<DataSheetFilterMetaQuestionInput>
    >;
    /**
     * Valid values are: LogicalAnd, LogicalOr
     * Defaults to LogicalAnd
     */
    readonly respondentMetaFilterMode?: InputMaybe<Scalars['String']['input']>;
    /** Limit the result to surveys that started on the specified dates */
    readonly surveyDates?: InputMaybe<ReadonlyArray<Scalars['Date']['input']>>;
    /** Limit the result to surveys that ended on the specified dates */
    readonly surveyEndDates?: InputMaybe<
        ReadonlyArray<Scalars['Date']['input']>
    >;
    /** Limit the results to project surveys with the specified survey meta responses */
    readonly surveyMetaFilter?: InputMaybe<
        ReadonlyArray<DataSheetFilterMetaQuestionInput>
    >;
    /** Limit results to a specific team */
    readonly teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type DataSheetFilterMetaQuestionInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly responseOptionValues: ReadonlyArray<Scalars['Int']['input']>;
};

export enum DataSheetFilterProjectBudgetCurrency {
    Eur = 'EUR',
    Sek = 'SEK',
    Usd = 'USD',
}

export type DataSheetFilterProjectBudgetInput = {
    readonly currency: DataSheetFilterProjectBudgetCurrency;
    readonly from?: InputMaybe<Scalars['Int64']['input']>;
    readonly to?: InputMaybe<Scalars['Int64']['input']>;
};

export type DataSheetFilterProjectInput = {
    readonly projectId: Scalars['ID']['input'];
    readonly surveyNumbers?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

export type DataSheetIndicatorResult = {
    readonly __typename?: 'DataSheetIndicatorResult';
    readonly indicatorId: Scalars['ID']['output'];
    readonly originalIndicatorId: Scalars['String']['output'];
    readonly result: DataSheetResult;
};

export type DataSheetMetaQuestionResponse = {
    readonly __typename?: 'DataSheetMetaQuestionResponse';
    readonly metaQuestionId: Scalars['ID']['output'];
    readonly originalMetaQuestionId: Scalars['ID']['output'];
    readonly responseOptionValue: Scalars['Int']['output'];
};

export type DataSheetMetaResult = {
    readonly respondentMetaGroupResults: ReadonlyArray<DataSheetRespondentMetaGroupResult>;
};

export type DataSheetQuestionResult = {
    readonly __typename?: 'DataSheetQuestionResult';
    readonly originalQuestionId: Scalars['String']['output'];
    readonly questionId: Scalars['ID']['output'];
    readonly result: DataSheetResult;
};

export type DataSheetRecipientTypeAnswerCount = {
    readonly __typename?: 'DataSheetRecipientTypeAnswerCount';
    readonly answerCount: Scalars['Int']['output'];
    readonly recipientType: RecipientType;
};

export type DataSheetRespondentMetaGroupResult = {
    readonly __typename?: 'DataSheetRespondentMetaGroupResult';
    /**
     * The number of answers from respondents in this meta group. This excludes when respondents responds
     * with "no opinion" in which case we dont count it as an answer, only a response.
     */
    readonly answerCount: Scalars['Int']['output'];
    /** The number of comments from respondents in this meta group */
    readonly commentCount: Scalars['Int']['output'];
    /**
     * This meta group is made from respondents that have these responses
     * to the meta questions.
     */
    readonly metaQuestionResponses: ReadonlyArray<DataSheetMetaQuestionResponse>;
    /** How many answers comes from the different recipient types? */
    readonly recipientTypeAnswerCounts: ReadonlyArray<DataSheetRecipientTypeAnswerCount>;
    /**
     * The number of resonses from respondents in this meta group. This includes when respondents responds
     * with "no opinion".
     */
    readonly responseCount: Scalars['Int']['output'];
    /** The number of surveys from respondents in this meta group */
    readonly surveyCount: Scalars['Int']['output'];
};

export type DataSheetResult = {
    readonly __typename?: 'DataSheetResult';
    /**
     * The number of answers to this question or indicator. If the response is "no opinion"
     * it is not calculated as an answer
     */
    readonly answerCount: Scalars['Int']['output'];
    readonly commentCount?: Maybe<Scalars['Int']['output']>;
    readonly improve?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Use DataSheetIndicatorResult.indicatorId */
    readonly indicatorId?: Maybe<Scalars['ID']['output']>;
    readonly negativeShare?: Maybe<Scalars['Float']['output']>;
    readonly neutralShare?: Maybe<Scalars['Float']['output']>;
    readonly noOpinion?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Use DataSheetIndicatorResult.originalIndicatorId */
    readonly originalIndicatorId?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use DataSheetIndicatorResult.originalQuestionId */
    readonly originalQuestionId?: Maybe<Scalars['String']['output']>;
    readonly positiveShare?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Use DataSheetIndicatorResult.questionId */
    readonly questionId?: Maybe<Scalars['ID']['output']>;
    readonly rating?: Maybe<Scalars['Float']['output']>;
    /** The number of responses to this question or indicator. Includes "no opinion" responses. */
    readonly responseCount: Scalars['Int']['output'];
};

/** A data sheet contains results aggregated by respondent meta groups from a single survey in a project. */
export type DataSheetSelection = {
    readonly __typename?: 'DataSheetSelection';
    readonly aggregatedDataSheet: AggregatedDataSheet;
    readonly dataSheets: ReadonlyArray<Maybe<DataSheet>>;
    readonly respondentMetaGroups: ReadonlyArray<DataSheetRespondentMetaGroupResult>;
};

/** Contains a response to a survey meta question. The key is a question id, and the value is a response option value */
export type DataSheetSurveyMeta = {
    readonly __typename?: 'DataSheetSurveyMeta';
    readonly key: Scalars['ID']['output'];
    readonly originalKey: Scalars['String']['output'];
    readonly value: Scalars['Int']['output'];
};

export type DeleteFileInput = {
    readonly filePath: Scalars['String']['input'];
};

export type DeleteFilePayload = {
    readonly __typename?: 'DeleteFilePayload';
    /**
     * Call this url with the DELETE method to actually delete the file.
     * If there is no url, you do not have permissions to delete the file.
     */
    readonly deleteFileUrl?: Maybe<Scalars['String']['output']>;
};

export type DeleteImprovementActivityInput = {
    readonly improvementActivityId: Scalars['ID']['input'];
};

export type DeleteImprovementActivityResponse = {
    readonly __typename?: 'DeleteImprovementActivityResponse';
    readonly areaOfImprovement?: Maybe<AreaOfImprovement>;
};

export type DeletePortfolioInput = {
    readonly portfolioId: Scalars['ID']['input'];
};

export type DeletePortfolioPayload = {
    readonly __typename?: 'DeletePortfolioPayload';
    /**
     * The first entry is always the deleted portfolio. The following entries are any descendant portfolios that was
     * deleted.
     */
    readonly deletedPortfolioIds?: Maybe<
        ReadonlyArray<Scalars['ID']['output']>
    >;
    readonly mainPortfolio?: Maybe<MainPortfolio>;
    readonly team?: Maybe<Team>;
};

export type DeleteProjectCategoryInput = {
    readonly projectCategoryId: Scalars['ID']['input'];
};

export type DeleteProjectCategoryResponse = {
    readonly __typename?: 'DeleteProjectCategoryResponse';
    readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProjectInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type DeleteProjectPayload = {
    readonly __typename?: 'DeleteProjectPayload';
    readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProjectSurveyTemplateInput = {
    readonly id: Scalars['ID']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type DeleteQuestionInput = {
    /** Used to fetch a questionnaire (optional) */
    readonly fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    /** Used to fetch a questionnaire (optional) */
    readonly locale?: InputMaybe<Scalars['LanguageTag']['input']>;
    readonly questionId: Scalars['ID']['input'];
    /** To fetch the questionnaire without the deleted question */
    readonly questionnaireId: Scalars['ID']['input'];
};

export type DeleteQuestionPayload = {
    readonly __typename?: 'DeleteQuestionPayload';
    readonly question?: Maybe<Question>;
    readonly questionnaire?: Maybe<Questionnaire>;
};

export type DescribeProjectCategoryInput = {
    readonly description: Scalars['String']['input'];
    readonly projectCategoryId: Scalars['ID']['input'];
};

export type DescribeProjectCategoryPayload = {
    readonly __typename?: 'DescribeProjectCategoryPayload';
    /** The updated project category */
    readonly projectCategory?: Maybe<ProjectCategory>;
};

export type Discussion = {
    readonly __typename?: 'Discussion';
    /** A list of comments for the discussion */
    readonly comments: ReadonlyArray<DiscussionComment>;
    readonly id: Scalars['ID']['output'];
};

export type DiscussionComment = {
    readonly __typename?: 'DiscussionComment';
    readonly author?: Maybe<User>;
    readonly authorId: Scalars['ID']['output'];
    readonly id: Scalars['ID']['output'];
    readonly text: Scalars['String']['output'];
    readonly writtenAt: Scalars['String']['output'];
};

export type Discussion_WriteCommentInput = {
    readonly commentText: Scalars['String']['input'];
    readonly discussionId: Scalars['ID']['input'];
};

export type Discussion_WriteCommentPayload = {
    readonly __typename?: 'Discussion_WriteCommentPayload';
    readonly comment: DiscussionComment;
};

export type DownloadInfo = {
    readonly __typename?: 'DownloadInfo';
    /** A unix timestamp */
    readonly expires: Scalars['Int']['output'];
    /** A filename */
    readonly filename: Scalars['String']['output'];
    /** The ID of this download. The download is accessible from /service/download/:id?/:filename */
    readonly id: Scalars['ID']['output'];
    /** The download can be found on this relative path on the API */
    readonly path: Scalars['String']['output'];
};

export type EndDashboardSubscriptionInput = {
    readonly endedAt: Scalars['Date']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type EndDashboardSubscriptionPayload = {
    readonly __typename?: 'EndDashboardSubscriptionPayload';
    readonly team?: Maybe<Team>;
};

export type Error = {
    readonly message: Scalars['String']['output'];
    readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type ExtendSurveyInput = {
    /**
     * Re-open the survey if it was already completed
     *
     * Defaults to false
     */
    readonly reopenIfCompleted?: InputMaybe<Scalars['Boolean']['input']>;
    readonly surveyId: Scalars['ID']['input'];
    /** When to close the survey */
    readonly until: Scalars['Date']['input'];
};

export type ExtendSurveyPayload = {
    readonly __typename?: 'ExtendSurveyPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type File = {
    readonly __typename?: 'File';
    /** The file name */
    readonly fileName: Scalars['String']['output'];
    /**
     * The file can be found on this relative path on the API. The path
     * includes the file name.
     */
    readonly path: Scalars['String']['output'];
    /** File size in bytes */
    readonly size: Scalars['Int']['output'];
};

export type FindTeamBasicInfoResult = {
    readonly __typename?: 'FindTeamBasicInfoResult';
    /** In case there is only a single unique match for your query it is returned here */
    readonly exactMatch?: Maybe<TeamBasicInfo>;
    /** Suggestions are listed if your query contained at least 3 characters */
    readonly suggestions?: Maybe<ReadonlyArray<TeamBasicInfo>>;
};

export type GrantTeamMemberAccessInput = {
    /**
     * The email of the user. If a user with the given email is not found, a new user will be created
     * with the provided name and email.
     */
    readonly email: Scalars['String']['input'];
    readonly firstName?: InputMaybe<Scalars['String']['input']>;
    readonly lastName?: InputMaybe<Scalars['String']['input']>;
    /**
     * The name of the user. If a user with the given email is found, this parameter will be ignored.
     * You can also use firstName and lastName for more control over the user name
     */
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly roles: ReadonlyArray<TeamMemberRoleInput>;
    readonly teamId: Scalars['ID']['input'];
};

export type GrantTeamMemberAccessPayload = {
    readonly __typename?: 'GrantTeamMemberAccessPayload';
    /** For each role that has is granted to a project, we include these projects here */
    readonly projects?: Maybe<ReadonlyArray<Project>>;
    readonly team?: Maybe<Team>;
};

export type ImprovementActivity = {
    readonly __typename?: 'ImprovementActivity';
    readonly areaOfImprovementId: Scalars['String']['output'];
    readonly completedBy?: Maybe<User>;
    readonly completedOn?: Maybe<Scalars['DateTime']['output']>;
    /**
     * The user who created this activity. If empty, it can mean two things. Either
     * the user has been removed, or the activity was created by a service
     */
    readonly createdBy?: Maybe<User>;
    readonly createdOn: Scalars['DateTime']['output'];
    readonly deadline?: Maybe<Scalars['DateTime']['output']>;
    readonly description?: Maybe<Scalars['String']['output']>;
    readonly goal?: Maybe<Scalars['String']['output']>;
    readonly id: Scalars['ID']['output'];
    readonly improvementActivityId: Scalars['String']['output'];
    readonly performanceReview?: Maybe<ImprovementActivityPerformanceReview>;
    readonly responsiblePerson?: Maybe<User>;
    readonly slug: Scalars['String']['output'];
    /** The start date will function as a reminder to start work on the activity.  */
    readonly startDate?: Maybe<Scalars['DateTime']['output']>;
    readonly summary: Scalars['String']['output'];
};

export type ImprovementActivityPerformanceReview = {
    readonly __typename?: 'ImprovementActivityPerformanceReview';
    readonly comment?: Maybe<Scalars['String']['output']>;
    readonly successRating: ImprovementActivityPerformanceReviewSuccessRating;
};

export type ImprovementActivityPerformanceReviewInput = {
    readonly comment?: InputMaybe<Scalars['String']['input']>;
    /**
     * A rating of 1 to 5
     *
     *     1 = NotAtAll
     *     2 = Slightly
     *     3 = Partially
     *     4 = Largely
     *     5 = Completely
     */
    readonly successRating: ImprovementActivityPerformanceReviewSuccessRating;
};

export enum ImprovementActivityPerformanceReviewSuccessRating {
    Completely = 'Completely',
    Largely = 'Largely',
    NotAtAll = 'NotAtAll',
    Partially = 'Partially',
    Slightly = 'Slightly',
}

export type ImprovementBank = {
    readonly __typename?: 'ImprovementBank';
    readonly areaOfImprovement?: Maybe<AreaOfImprovement>;
    readonly areasOfImprovement: ReadonlyArray<AreaOfImprovement>;
    readonly id: Scalars['ID']['output'];
    readonly improvementActivities: ReadonlyArray<ImprovementActivity>;
    readonly improvementBankId: Scalars['String']['output'];
};

export type ImprovementBankAreaOfImprovementArgs = {
    slug?: InputMaybe<Scalars['String']['input']>;
};

export type Indicator = {
    readonly __typename?: 'Indicator';
    readonly id: Scalars['ID']['output'];
    readonly key: Scalars['String']['output'];
    readonly name: Scalars['String']['output'];
    readonly originalId: Scalars['String']['output'];
    readonly originalQuestionIds: ReadonlyArray<Scalars['String']['output']>;
    readonly questionIds: ReadonlyArray<Scalars['ID']['output']>;
};

export type IndicatorBestPractice = BestPractice & {
    readonly __typename?: 'IndicatorBestPractice';
    readonly P10: Scalars['Float']['output'];
    readonly P25: Scalars['Float']['output'];
    readonly P75: Scalars['Float']['output'];
    readonly P90: Scalars['Float']['output'];
    readonly indicatorId: Scalars['ID']['output'];
    readonly originalIndicatorId: Scalars['String']['output'];
};

export type IndicatorResult = Result & {
    readonly __typename?: 'IndicatorResult';
    readonly answerCount: Scalars['Int']['output'];
    readonly average?: Maybe<Scalars['Float']['output']>;
    readonly improvePercent?: Maybe<Scalars['Float']['output']>;
    readonly indicatorKey: Scalars['String']['output'];
    readonly percentiles?: Maybe<ReadonlyArray<PercentileResult>>;
    readonly resultType: ResultType;
    readonly signalSpread?: Maybe<ReadonlyArray<SignalResult>>;
};

export type IndicatorTranslation = {
    readonly __typename?: 'IndicatorTranslation';
    readonly id: Scalars['ID']['output'];
    readonly indicatorId: Scalars['ID']['output'];
    readonly locale: Scalars['LanguageTag']['output'];
    readonly name: Scalars['String']['output'];
};

export type InvoiceInformation = {
    readonly __typename?: 'InvoiceInformation';
    readonly customerReference?: Maybe<Scalars['String']['output']>;
    readonly emailAddress?: Maybe<Scalars['String']['output']>;
    readonly instructionsForSupplier?: Maybe<Scalars['String']['output']>;
    readonly mailingAddress?: Maybe<MailingAddress>;
    readonly organization?: Maybe<InvoiceOrganization>;
    readonly otherLabeling?: Maybe<Scalars['String']['output']>;
    readonly typeOfInvoice?: Maybe<TypeOfInvoice>;
};

export type InvoiceInformationInput = {
    readonly customerReference?: InputMaybe<Scalars['String']['input']>;
    readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
    readonly instructionsForSupplier?: InputMaybe<Scalars['String']['input']>;
    readonly mailingAddress?: InputMaybe<MailingAddressInput>;
    readonly organization?: InputMaybe<InvoiceOrganizationInput>;
    readonly otherLabeling?: InputMaybe<Scalars['String']['input']>;
    readonly typeOfInvoice: TypeOfInvoice;
};

export type InvoiceOrganization = {
    readonly __typename?: 'InvoiceOrganization';
    readonly organizationName?: Maybe<Scalars['String']['output']>;
    readonly organizationNumber?: Maybe<Scalars['String']['output']>;
};

export type InvoiceOrganizationInput = {
    readonly organizationName?: InputMaybe<Scalars['String']['input']>;
    readonly organizationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LocaleInfo = {
    readonly __typename?: 'LocaleInfo';
    readonly id: Scalars['ID']['output'];
    readonly inLocaleId: Scalars['String']['output'];
    readonly languageName: Scalars['String']['output'];
    readonly localeId: Scalars['String']['output'];
    readonly nativeLanguageName: Scalars['String']['output'];
    readonly nativeTerritoryName: Scalars['String']['output'];
    readonly territoryName: Scalars['String']['output'];
};

export type MailingAddress = {
    readonly __typename?: 'MailingAddress';
    readonly country: Scalars['String']['output'];
    readonly postalAddress: Scalars['String']['output'];
    readonly postalAddress2: Scalars['String']['output'];
    readonly postalCode: Scalars['String']['output'];
    readonly postalTown: Scalars['String']['output'];
};

export type MailingAddressInput = {
    readonly country: Scalars['String']['input'];
    readonly postalAddress: Scalars['String']['input'];
    readonly postalAddress2?: InputMaybe<Scalars['String']['input']>;
    readonly postalCode: Scalars['String']['input'];
    readonly postalTown: Scalars['String']['input'];
};

/** There can only be one main portfolio. It does not have a name, path or parent, like SubPortfolio do */
export type MainPortfolio = Portfolio & {
    readonly __typename?: 'MainPortfolio';
    readonly id: Scalars['ID']['output'];
    readonly project?: Maybe<ProjectInterface>;
    readonly projectCount: Scalars['Int']['output'];
    readonly projectSurveys: ReadonlyArray<ProjectSurvey>;
    readonly projects: ReadonlyArray<ProjectInterface>;
    readonly subPortfolios: ReadonlyArray<SubPortfolio>;
    readonly team: Team;
    readonly teamId: Scalars['ID']['output'];
    readonly totalProjectCount: Scalars['Int']['output'];
};

/** There can only be one main portfolio. It does not have a name, path or parent, like SubPortfolio do */
export type MainPortfolioProjectArgs = {
    path: Scalars['String']['input'];
};

/** There can only be one main portfolio. It does not have a name, path or parent, like SubPortfolio do */
export type MainPortfolioProjectSurveysArgs = {
    filter?: InputMaybe<ProjectSurveyFilterInput>;
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** There can only be one main portfolio. It does not have a name, path or parent, like SubPortfolio do */
export type MainPortfolioProjectsArgs = {
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
    onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

/** There can only be one main portfolio. It does not have a name, path or parent, like SubPortfolio do */
export type MainPortfolioSubPortfoliosArgs = {
    directChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkImprovementActivityAsCompletedInput = {
    readonly improvementActivityId: Scalars['ID']['input'];
    readonly performanceReview?: InputMaybe<ImprovementActivityPerformanceReviewInput>;
};

export type MarkImprovementActivityAsCompletedResponse = {
    readonly __typename?: 'MarkImprovementActivityAsCompletedResponse';
    readonly improvementActivity?: Maybe<ImprovementActivity>;
};

export type MarkProjectAsCompletedInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type MarkProjectAsCompletedPayload = {
    readonly __typename?: 'MarkProjectAsCompletedPayload';
    readonly project?: Maybe<Project>;
};

export type MetaResult = {
    readonly __typename?: 'MetaResult';
    readonly id: Scalars['ID']['output'];
    readonly metaKey?: Maybe<Scalars['String']['output']>;
    readonly metaValue?: Maybe<Scalars['String']['output']>;
    readonly responseCount?: Maybe<Scalars['Int']['output']>;
};

export type Money = {
    readonly __typename?: 'Money';
    readonly amount: Scalars['Decimal']['output'];
    readonly currency: Scalars['String']['output'];
};

export type MoneyInput = {
    readonly amount: Scalars['Decimal']['input'];
    /** The currency code follows the 3-letter standard described here: https://www.iban.com/currency-codes */
    readonly currency: Scalars['String']['input'];
};

export type MovePortfolioInput = {
    /**
     * The organization main portfolio id can be used as parent id as well as any sub portfolio id.
     * The maximum levels of sub-portfolios is 3.
     */
    readonly parentPortfolioId: Scalars['ID']['input'];
    /** Id of the portfolio that should be moved */
    readonly portfolioId: Scalars['ID']['input'];
};

export type MovePortfolioPayload = {
    readonly __typename?: 'MovePortfolioPayload';
    /** The portfolio that was moved */
    readonly portfolio?: Maybe<SubPortfolio>;
};

export type MoveProjectToPortfolioInput = {
    readonly portfolioId: Scalars['ID']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type MoveProjectToPortfolioPayload = {
    readonly __typename?: 'MoveProjectToPortfolioPayload';
    readonly project?: Maybe<ProjectInterface>;
};

export type Mutation = {
    readonly __typename?: 'Mutation';
    readonly acceptProjectSubscriptionTerms: AcceptProjectSubscriptionTermsPayload;
    /**
     * Activates the survey. This means that the survey will be sent at the
     * scheduled date/time.
     */
    readonly activateSurvey: ActivateSurveyPayload;
    readonly addPortfolio?: Maybe<AddPortfolioPayload>;
    readonly addProjectCategory?: Maybe<AddProjectCategoryPayload>;
    readonly addProjectSurvey: AddProjectSurveyPayload;
    readonly addProjectSurveyTemplate: ProjectSurveyTemplateMutationPayload;
    /** Adds a new question to a questionnaire */
    readonly addQuestion: AddQuestionPayload;
    readonly addQuestionToIndicator?: Maybe<AddQuestionToIndicatorPayload>;
    readonly addQuestionToSection: AddQuestionToSectionPayload;
    readonly addRecipientToList: AddRecipientToListPayload;
    readonly addRecipientsToList: AddRecipientsToListPayload;
    /** Use a survey code to create a new respondent */
    readonly addRespondentFromSurveyCode: AddRespondentFromSurveyCodePayload;
    readonly addVisibilityCondition: AddVisibilityConditionPayload;
    /** Assign a project category to the project. Works for both Project and ReceivedProject */
    readonly assignProjectCategory: AssignProjectCategoryPayload;
    /**
     * Assign a project manager (Will be replaced by assignResponsiblePerson). Works for both Project and ReceivedProject
     *
     * A new user will be created if there is none already for the given email address. This user
     * will not have a password assigned, so the user must use the forgot password functionality
     * until a smoother login experience is created.
     *
     * NOTE: If an existing user if found, it will not be updated. The fields name,
     * firstName and lastName is only used when adding a new user.
     */
    readonly assignProjectManager: AssignProjectManagerPayload;
    /**
     * Assign a project survey planner
     *
     * A new user will be created if there is none already for the given email address. This user
     * will not have a password assigned, so the user must use the forgot password functionality
     * until a smoother login experience is created.
     *
     * NOTE: If the email matches an existing user, the name field will be ignored
     */
    readonly assignProjectSurveyPlanner: AssignProjectSurveyPlannerPayload;
    /**
     * Assign a project survey sender
     *
     * A new user will be created if there is none already for the given email address. This user
     * will not have a password assigned, so the user must use the forgot password functionality
     * until a smoother login experience is created.
     *
     * NOTE: If the email matches an existing user, the name field will be ignored
     */
    readonly assignProjectSurveySender: AssignProjectSurveySenderPayload;
    readonly assignTeamContactPersons: AssignTeamContactPersonsPayload;
    readonly assignTeamIndustryConnections: AssignTeamIndustryConnectionsPayload;
    readonly budgetYearlyProjectSurveys: BudgetYearlyProjectSurveysPayload;
    /** Change the questions for this indicator. You can use this to add, remove or change the order of the questions. */
    readonly changeIndicatorQuestions?: Maybe<ChangeIndicatorQuestionsPayload>;
    /** Changes the last day that the survey will be open for answers */
    readonly changeProjectSurveyEndDate: ChangeProjectSurveyEndDateResponse;
    /**
     * Changes the language the we use for invitations, reminders and default respondent
     * locale.
     */
    readonly changeRecipientListLocale: ChangeRecipientListLocalePayload;
    /** Changes the survey language for the respondent */
    readonly changeRespondentLocale: ChangeRespondentLocalePayload;
    readonly changeSurveyDate: ChangeSurveyDatePayload;
    readonly changeSurveyTemplateForProjectSurvey: ChangeSurveyTemplateForProjectSurveyPayload;
    readonly changeSurveyTime: ChangeSurveyTimePayload;
    readonly changeTeamOrganizationNumber: ChangeTeamOrganizationNumberPayload;
    readonly changeUserSettings: ChangeUserSettingsPayload;
    readonly closeSurvey: CloseSurveyPayload;
    readonly confirmPreliminaryProjectSurvey: ConfirmPreliminaryProjectSurveyPayload;
    /**
     * Corrects a previous meta question response. This is intended to be used by
     * admins, not the respondent, and is allowed even after a
     * survey is closed.
     */
    readonly correctMetaQuestionResponse: CorrectMetaQuestionResponsePayload;
    readonly createAreaOfImprovement?: Maybe<CreateAreaOfImprovementResponse>;
    readonly createImprovementActivity?: Maybe<CreateImprovementActivityResponse>;
    readonly createImprovementBankForProject?: Maybe<CreateImprovementBankForProjectResponse>;
    readonly createProject?: Maybe<CreateProjectPayload>;
    readonly createTeam: CreateTeamPayload;
    /** Customized which indicators and questions that should be used in a questionnaire */
    readonly customizeQuestionnaire: CustomizeQuestionnairePayload;
    readonly deleteFile?: Maybe<DeleteFilePayload>;
    readonly deleteImprovementActivity?: Maybe<DeleteImprovementActivityResponse>;
    readonly deletePortfolio?: Maybe<DeletePortfolioPayload>;
    readonly deleteProject?: Maybe<DeleteProjectPayload>;
    readonly deleteProjectCategory: DeleteProjectCategoryResponse;
    readonly deleteProjectSurveyTemplate: ProjectSurveyTemplateMutationPayload;
    /**
     * Deletes a question. If the question has been used, it is recommended to hide
     * questions instead (using the updateQuestion mutation)
     */
    readonly deleteQuestion: DeleteQuestionPayload;
    readonly describeProjectCategory?: Maybe<DescribeProjectCategoryPayload>;
    readonly discussion_writeComment: Discussion_WriteCommentPayload;
    readonly endDashboardSubscription?: Maybe<EndDashboardSubscriptionPayload>;
    readonly extendSurvey: ExtendSurveyPayload;
    readonly grantTeamMemberAccess: GrantTeamMemberAccessPayload;
    readonly markImprovementActivityAsCompleted?: Maybe<MarkImprovementActivityAsCompletedResponse>;
    /**
     * Changes the status of the project to "COMPLETED". After doing so, all survey recipients will be
     * anonymized as there is no longer a purpose for keeping that information.
     */
    readonly markProjectAsCompleted: MarkProjectAsCompletedPayload;
    /** Move this portfolio to a new parent */
    readonly movePortfolio?: Maybe<MovePortfolioPayload>;
    /** Move a project to another portfolio. Works for both Project and ReceivedProject */
    readonly moveProjectToPortfolio?: Maybe<MoveProjectToPortfolioPayload>;
    /** Pauses an active project. Note that this does not affect the project subscription */
    readonly pauseProject: PauseProjectPayload;
    readonly planPreliminaryProjectSurveys: PlanPreliminaryProjectSurveysPayload;
    /** Pre-register a meta-question responses for a respondent */
    readonly preRegisterMetaQuestionResponses: PreRegisterMetaQuestionResponsesPayload;
    readonly recallProjectSubscriptionCancellationRequest: RecallProjectSubscriptionCancellationRequestPayload;
    readonly registerProjectInvoiceInformation: RegisterProjectInvoiceInformationPayload;
    readonly registerProjectSubscriptionDiscountCode: RegisterProjectSubscriptionDiscountCodePayload;
    readonly registerQuestionResponse: RegisterQuestionResponsePayload;
    /**
     * Register a question response for the recipient list.
     * Responses on the recipient list affects all respondents
     */
    readonly registerRecipientListQuestionResponse: RegisterRecipientListQuestionResponsePayload;
    readonly registerRespondentConsent: RegisterRespondentConsentPayload;
    readonly registerTeamInvoiceInformation: RegisterTeamInvoiceInformationPayload;
    readonly remindRecipients: RemindRecipientsPayload;
    readonly removeRecipientsFromList: RemoveRecipientsFromListPayload;
    /**
     * A respondent may remove themself from a survey if they feel that the survey
     * is not for them
     */
    readonly removeSelfAsRespondent: RemoveSelfAsRespondentPayload;
    readonly removeSurvey: RemoveSurveyPayload;
    readonly renamePortfolio?: Maybe<RenamePortfolioPayload>;
    /** Rename project. Works for both Project and ReceivedProject */
    readonly renameProject?: Maybe<RenameProjectPayload>;
    readonly renameProjectCategory?: Maybe<RenameProjectCategoryPayload>;
    readonly renameTeam?: Maybe<RenameTeamPayload>;
    readonly renewDashboardSubscription?: Maybe<RenewDashboardSubscriptionPayload>;
    readonly reopenSurvey: ReopenSurveyPayload;
    readonly requestProjectSubscriptionCancellation: RequestProjectSubscriptionCancellationPayload;
    /**
     * Updates the questionnaire version used in a recipient list. Operation is only
     * allowed while the RecipientListStatus is SURVEY_NOT_OPEN
     */
    readonly requestStableQuestionnaireVersionForRecipientList?: Maybe<RequestStableQuestionnaireVersionForRecipientListPayload>;
    readonly requestUploadOfDashboardSubscriptionContract?: Maybe<RequestUploadOfDashboardSubscriptionContractPayload>;
    /**
     * Resumes a paused or completed project. Changes the status of the project to "OK" (active). A completed project
     * likely contains anonymized data.
     */
    readonly resumeProject: ResumeProjectPayload;
    readonly revokeTeamMemberAccess: RevokeTeamMemberAccessPayload;
    readonly selectProjectSurveySender: SelectProjectSurveySenderPayload;
    /** Sets or updates the project budget. */
    readonly setProjectBudget: SetProjectBudgetPayload;
    readonly setProjectLocation: SetProjectLocationPayload;
    /** Sets or updates the project budget for a received project.  */
    readonly setReceivedProjectBudget: SetReceivedProjectBudgetPayload;
    /** Adds or updates a project team share.  */
    readonly shareProjectWithTeam: ShareProjectWithTeamResponse;
    readonly sortProjectCategories: SortProjectCategoriesResponse;
    readonly sortProjectSurveyTemplates: ProjectSurveyTemplateMutationPayload;
    /** Sort questions */
    readonly sortQuestions: SortQuestionsPayload;
    readonly startDashboardSubscription?: Maybe<StartDashboardSubscriptionPayload>;
    /**
     * Toggle if this team/organization should be allowed to receive shared projects from other organizations.
     *
     * NOTE: This is for teams with an active portfolio subscription. For teams
     * without a portfolio subscription, Binosight may enable this for you in special cases.
     */
    readonly toggleAllowReceiveSharedProjects: ToggleAllowReceiveSharedProjectsResponse;
    readonly toggleTeamMemberNotification: ToggleTeamMemberNotificationPayload;
    readonly toggleTeamMemberProjectSurveyNotifications: ToggleTeamMemberProjectSurveyNotificationsPayload;
    /** Adds or updates a question translation */
    readonly translateQuestion: TranslateQuestionPayload;
    /** Undoes that a respondent removed themself from the the survey */
    readonly undoRemoveSelfAsRespondent: UndoRemoveSelfAsRespondentPayload;
    /**
     * Unlock project survey results to enable deeper analysis and download
     * of PQi Quality Report and PQi Feedback.
     *
     * By unlocking project survey results you accept that it might incur a one-time cost, based on the Binosight
     * price list at https://binosight.com/pricing, depending on your organization's agreement with Binosight.
     */
    readonly unlockProjectSurveyResults: UnlockProjectSurveyResultsPayload;
    readonly unmarkImprovementActivityAsCompleted?: Maybe<UnmarkImprovementActivityAsCompletedResponse>;
    /** Completely removes a project team share.  */
    readonly unshareProjectWithTeam: UnshareProjectWithTeamResponse;
    readonly updateActiveDashboardSubscription?: Maybe<UpdateActiveDashboardSubscriptionPayload>;
    readonly updateAreaOfImprovement?: Maybe<UpdateAreaOfImprovementResponse>;
    readonly updateImprovementActivity?: Maybe<UpdateImprovementActivityResponse>;
    readonly updateProjectSurveyTemplate: ProjectSurveyTemplateMutationPayload;
    /** Update question properties */
    readonly updateQuestion: UpdateQuestionPayload;
    readonly updateVisibilityCondition: UpdateVisibilityConditionPayload;
    readonly useCustomPriceList?: Maybe<UseCustomPriceListPayload>;
    readonly useDefaultPriceList?: Maybe<UseDefaultPriceListPayload>;
};

export type MutationAcceptProjectSubscriptionTermsArgs = {
    input: AcceptProjectSubscriptionTermsInput;
};

export type MutationActivateSurveyArgs = {
    input: ActivateSurveyInput;
};

export type MutationAddPortfolioArgs = {
    input: AddPortfolioInput;
};

export type MutationAddProjectCategoryArgs = {
    input: AddProjectCategoryInput;
};

export type MutationAddProjectSurveyArgs = {
    input: AddProjectSurveyInput;
};

export type MutationAddProjectSurveyTemplateArgs = {
    input: AddProjectSurveyTemplateInput;
};

export type MutationAddQuestionArgs = {
    input: AddQuestionInput;
};

export type MutationAddQuestionToIndicatorArgs = {
    input: AddQuestionToIndicatorInput;
};

export type MutationAddQuestionToSectionArgs = {
    input: AddQuestionToSectionInput;
};

export type MutationAddRecipientToListArgs = {
    input: AddRecipientToListInput;
};

export type MutationAddRecipientsToListArgs = {
    input: AddRecipientsToListInput;
};

export type MutationAddRespondentFromSurveyCodeArgs = {
    input: AddRespondentFromSurveyCodeInput;
};

export type MutationAddVisibilityConditionArgs = {
    input: AddVisibilityConditionInput;
};

export type MutationAssignProjectCategoryArgs = {
    input: AssignProjectCategoryInput;
};

export type MutationAssignProjectManagerArgs = {
    input: AssignProjectManagerInput;
};

export type MutationAssignProjectSurveyPlannerArgs = {
    input: AssignProjectSurveyPlannerInput;
};

export type MutationAssignProjectSurveySenderArgs = {
    input: AssignProjectSurveySenderInput;
};

export type MutationAssignTeamContactPersonsArgs = {
    input: AssignTeamContactPersonsInput;
};

export type MutationAssignTeamIndustryConnectionsArgs = {
    input: AssignTeamIndustryConnectionsInput;
};

export type MutationBudgetYearlyProjectSurveysArgs = {
    input: BudgetYearlyProjectSurveysInput;
};

export type MutationChangeIndicatorQuestionsArgs = {
    input: ChangeIndicatorQuestionsInput;
};

export type MutationChangeProjectSurveyEndDateArgs = {
    input: ChangeProjectSurveyEndDateInput;
};

export type MutationChangeRecipientListLocaleArgs = {
    input: ChangeRecipientListLocaleInput;
};

export type MutationChangeRespondentLocaleArgs = {
    input: ChangeRespondentLocaleInput;
};

export type MutationChangeSurveyDateArgs = {
    input: ChangeSurveyDateInput;
};

export type MutationChangeSurveyTemplateForProjectSurveyArgs = {
    input: ChangeSurveyTemplateForProjectSurveyInput;
};

export type MutationChangeSurveyTimeArgs = {
    input: ChangeSurveyTimeInput;
};

export type MutationChangeTeamOrganizationNumberArgs = {
    input: ChangeTeamOrganizationNumberInput;
};

export type MutationChangeUserSettingsArgs = {
    input: ChangeUserSettingsInput;
};

export type MutationCloseSurveyArgs = {
    input: CloseSurveyInput;
};

export type MutationConfirmPreliminaryProjectSurveyArgs = {
    input: ConfirmPreliminaryProjectSurveyInput;
};

export type MutationCorrectMetaQuestionResponseArgs = {
    input: RegisterQuestionResponseInput;
};

export type MutationCreateAreaOfImprovementArgs = {
    input: CreateAreaOfImprovementInput;
};

export type MutationCreateImprovementActivityArgs = {
    input: CreateImprovementActivityInput;
};

export type MutationCreateImprovementBankForProjectArgs = {
    input: CreateImprovementBankForProjectInput;
};

export type MutationCreateProjectArgs = {
    input: CreateProjectInput;
};

export type MutationCreateTeamArgs = {
    input: CreateTeamInput;
};

export type MutationCustomizeQuestionnaireArgs = {
    input: CustomizeQuestionnaireInput;
};

export type MutationDeleteFileArgs = {
    input: DeleteFileInput;
};

export type MutationDeleteImprovementActivityArgs = {
    input: DeleteImprovementActivityInput;
};

export type MutationDeletePortfolioArgs = {
    input: DeletePortfolioInput;
};

export type MutationDeleteProjectArgs = {
    input: DeleteProjectInput;
};

export type MutationDeleteProjectCategoryArgs = {
    input: DeleteProjectCategoryInput;
};

export type MutationDeleteProjectSurveyTemplateArgs = {
    input: DeleteProjectSurveyTemplateInput;
};

export type MutationDeleteQuestionArgs = {
    input: DeleteQuestionInput;
};

export type MutationDescribeProjectCategoryArgs = {
    input: DescribeProjectCategoryInput;
};

export type MutationDiscussion_WriteCommentArgs = {
    input: Discussion_WriteCommentInput;
};

export type MutationEndDashboardSubscriptionArgs = {
    input: EndDashboardSubscriptionInput;
};

export type MutationExtendSurveyArgs = {
    input: ExtendSurveyInput;
};

export type MutationGrantTeamMemberAccessArgs = {
    input: GrantTeamMemberAccessInput;
};

export type MutationMarkImprovementActivityAsCompletedArgs = {
    input: MarkImprovementActivityAsCompletedInput;
};

export type MutationMarkProjectAsCompletedArgs = {
    input: MarkProjectAsCompletedInput;
};

export type MutationMovePortfolioArgs = {
    input: MovePortfolioInput;
};

export type MutationMoveProjectToPortfolioArgs = {
    input: MoveProjectToPortfolioInput;
};

export type MutationPauseProjectArgs = {
    input: PauseProjectInput;
};

export type MutationPlanPreliminaryProjectSurveysArgs = {
    input: PlanPreliminaryProjectSurveysInput;
};

export type MutationPreRegisterMetaQuestionResponsesArgs = {
    input: PreRegisterMetaQuestionResponsesInput;
};

export type MutationRecallProjectSubscriptionCancellationRequestArgs = {
    input: RecallProjectSubscriptionCancellationRequestInput;
};

export type MutationRegisterProjectInvoiceInformationArgs = {
    input: RegisterProjectInvoiceInformationInput;
};

export type MutationRegisterProjectSubscriptionDiscountCodeArgs = {
    input: RegisterProjectSubscriptionDiscountCodeInput;
};

export type MutationRegisterQuestionResponseArgs = {
    input: RegisterQuestionResponseInput;
};

export type MutationRegisterRecipientListQuestionResponseArgs = {
    input: RegisterRecipientListQuestionResponseInput;
};

export type MutationRegisterRespondentConsentArgs = {
    input: RegisterRespondentConsentInput;
};

export type MutationRegisterTeamInvoiceInformationArgs = {
    input: RegisterTeamInvoiceInformationInput;
};

export type MutationRemindRecipientsArgs = {
    input: RemindRecipientsInput;
};

export type MutationRemoveRecipientsFromListArgs = {
    input: RemoveRecipientsFromListInput;
};

export type MutationRemoveSelfAsRespondentArgs = {
    input: RemoveSelfAsRespondentInput;
};

export type MutationRemoveSurveyArgs = {
    input: RemoveSurveyInput;
};

export type MutationRenamePortfolioArgs = {
    input: RenamePortfolioInput;
};

export type MutationRenameProjectArgs = {
    input: RenameProjectInput;
};

export type MutationRenameProjectCategoryArgs = {
    input: RenameProjectCategoryInput;
};

export type MutationRenameTeamArgs = {
    input: RenameTeamInput;
};

export type MutationRenewDashboardSubscriptionArgs = {
    input: RenewDashboardSubscriptionInput;
};

export type MutationReopenSurveyArgs = {
    input: ReopenSurveyInput;
};

export type MutationRequestProjectSubscriptionCancellationArgs = {
    input: RequestProjectSubscriptionCancellationInput;
};

export type MutationRequestStableQuestionnaireVersionForRecipientListArgs = {
    input: RequestStableQuestionnaireVersionForRecipientListInput;
};

export type MutationRequestUploadOfDashboardSubscriptionContractArgs = {
    input: RequestUploadOfDashboardSubscriptionContractInput;
};

export type MutationResumeProjectArgs = {
    input: ResumeProjectInput;
};

export type MutationRevokeTeamMemberAccessArgs = {
    input: RevokeTeamMemberAccessInput;
};

export type MutationSelectProjectSurveySenderArgs = {
    input: SelectProjectSurveySenderInput;
};

export type MutationSetProjectBudgetArgs = {
    input: SetProjectBudgetInput;
};

export type MutationSetProjectLocationArgs = {
    input: SetProjectLocationInput;
};

export type MutationSetReceivedProjectBudgetArgs = {
    input: SetReceivedProjectBudgetInput;
};

export type MutationShareProjectWithTeamArgs = {
    input: ShareProjectWithTeamInput;
};

export type MutationSortProjectCategoriesArgs = {
    input: SortProjectCategoriesInput;
};

export type MutationSortProjectSurveyTemplatesArgs = {
    input: SortProjectSurveyTemplatesInput;
};

export type MutationSortQuestionsArgs = {
    input: SortQuestionsInput;
};

export type MutationStartDashboardSubscriptionArgs = {
    input: StartDashboardSubscriptionInput;
};

export type MutationToggleAllowReceiveSharedProjectsArgs = {
    input: ToggleAllowReceiveSharedProjectsInput;
};

export type MutationToggleTeamMemberNotificationArgs = {
    input: ToggleTeamMemberNotificationInput;
};

export type MutationToggleTeamMemberProjectSurveyNotificationsArgs = {
    input: ToggleTeamMemberProjectSurveyNotificationsInput;
};

export type MutationTranslateQuestionArgs = {
    input: TranslateQuestionInput;
};

export type MutationUndoRemoveSelfAsRespondentArgs = {
    input: UndoRemoveSelfAsRespondentInput;
};

export type MutationUnlockProjectSurveyResultsArgs = {
    input: UnlockProjectSurveyResultsInput;
};

export type MutationUnmarkImprovementActivityAsCompletedArgs = {
    input: UnmarkImprovementActivityAsCompletedInput;
};

export type MutationUnshareProjectWithTeamArgs = {
    input: UnshareProjectWithTeamInput;
};

export type MutationUpdateActiveDashboardSubscriptionArgs = {
    input: UpdateActiveDashboardSubscriptionInput;
};

export type MutationUpdateAreaOfImprovementArgs = {
    input: UpdateAreaOfImprovementInput;
};

export type MutationUpdateImprovementActivityArgs = {
    input: UpdateImprovementActivityInput;
};

export type MutationUpdateProjectSurveyTemplateArgs = {
    input: UpdateProjectSurveyTemplateInput;
};

export type MutationUpdateQuestionArgs = {
    input: UpdateQuestionInput;
};

export type MutationUpdateVisibilityConditionArgs = {
    input: UpdateVisibilityConditionInput;
};

export type MutationUseCustomPriceListArgs = {
    input: UseCustomPriceListInput;
};

export type MutationUseDefaultPriceListArgs = {
    input: UseDefaultPriceListInput;
};

/** An object with an ID */
export type Node = {
    /** The id of the object. */
    readonly id: Scalars['ID']['output'];
};

export enum PQiTeamMemberNotificationType {
    /** Get notified when a survey is completed in a project */
    ProjectSurveyCompleted = 'ProjectSurveyCompleted',
    /** Get notified when a survey is started in a project */
    ProjectSurveyStarted = 'ProjectSurveyStarted',
}

export type PQiUser = Node & {
    readonly __typename?: 'PQiUser';
    readonly authUser?: Maybe<User>;
    readonly enabledNotifications: ReadonlyArray<PQiUserNotification>;
    readonly grants: ReadonlyArray<PQiUserGrant>;
    readonly id: Scalars['ID']['output'];
};

export type PQiUserGrant = {
    readonly __typename?: 'PQiUserGrant';
    readonly portfolioId?: Maybe<Scalars['ID']['output']>;
    readonly projectId?: Maybe<Scalars['ID']['output']>;
    readonly role: TeamMemberRoleName;
    readonly teamId?: Maybe<Scalars['ID']['output']>;
};

export type PQiUserNotification = {
    readonly __typename?: 'PQiUserNotification';
    readonly portfolioId?: Maybe<Scalars['ID']['output']>;
    readonly teamId?: Maybe<Scalars['ID']['output']>;
    readonly type: PQiTeamMemberNotificationType;
};

export type PauseProjectInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type PauseProjectPayload = {
    readonly __typename?: 'PauseProjectPayload';
    readonly project?: Maybe<Project>;
};

export type PercentileResult = {
    readonly __typename?: 'PercentileResult';
    readonly rank: Scalars['Int']['output'];
    readonly value?: Maybe<Scalars['Float']['output']>;
};

export type PlanPreliminaryProjectSurveysInput = {
    /** A list of dates for preliminary surveys */
    readonly dates: ReadonlyArray<Scalars['Date']['input']>;
    readonly projectId: Scalars['ID']['input'];
};

export type PlanPreliminaryProjectSurveysPayload = {
    readonly __typename?: 'PlanPreliminaryProjectSurveysPayload';
    readonly project?: Maybe<Project>;
};

export type Portfolio = {
    readonly id: Scalars['ID']['output'];
    /** Get a single project by its path */
    readonly project?: Maybe<ProjectInterface>;
    /** The number of projects in this portfolio, not including any descendant portfolios */
    readonly projectCount: Scalars['Int']['output'];
    /** List all project surveys in this portfolio and all descendant portfolios unless you specify fromThisPortfolioOnly: true */
    readonly projectSurveys: ReadonlyArray<ProjectSurvey>;
    /** List all projects in this portfolio and all descendant portfolios unless you specify fromThisPortfolioOnly: true */
    readonly projects: ReadonlyArray<ProjectInterface>;
    /** We allow up to 3 levels of sub-portfolios. To query every portfolio this way you have to nest your query 3 levels */
    readonly subPortfolios: ReadonlyArray<SubPortfolio>;
    readonly team: Team;
    readonly teamId: Scalars['ID']['output'];
    /** The number of projects in this portfolio, including projects from all all descendant portfolios */
    readonly totalProjectCount: Scalars['Int']['output'];
};

export type PortfolioProjectArgs = {
    path: Scalars['String']['input'];
};

export type PortfolioProjectSurveysArgs = {
    filter?: InputMaybe<ProjectSurveyFilterInput>;
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortfolioProjectsArgs = {
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
    onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortfolioSubPortfoliosArgs = {
    directChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PreRegisterMetaQuestionResponseInput = {
    readonly questionResponse: QuestionResponseInput;
    readonly respondentId: Scalars['ID']['input'];
};

export type PreRegisterMetaQuestionResponsePayload = {
    readonly __typename?: 'PreRegisterMetaQuestionResponsePayload';
    readonly questionResponse?: Maybe<QuestionResponse>;
};

export type PreRegisterMetaQuestionResponsesInput = {
    readonly metaQuestionResponses: ReadonlyArray<QuestionResponseInput>;
    readonly respondentId: Scalars['ID']['input'];
};

export type PreRegisterMetaQuestionResponsesPayload = {
    readonly __typename?: 'PreRegisterMetaQuestionResponsesPayload';
    readonly metaQuestionResponses?: Maybe<ReadonlyArray<QuestionResponse>>;
};

export type Project = Node &
    ProjectInterface & {
        readonly __typename?: 'Project';
        readonly acceptedGeneralTermsAndConditions: Scalars['Boolean']['output'];
        /** @deprecated Use subscription.acceptedTermsAndConditions */
        readonly acceptedProjectSubscriptionTermsAndConditions?: Maybe<
            Scalars['Boolean']['output']
        >;
        /** Estimated project budget */
        readonly budget?: Maybe<ProjectBudget>;
        readonly createdAt: Scalars['DateTime']['output'];
        readonly createdBy: User;
        /**
         * Fetch the current survey.
         *
         * Definition: The first survey that is not completed
         *
         * The current survey is what you should focus on. When there are no surveys, or all surveys are completed, the
         * next survey in line is the current survey. The survey status is anything by \`COMPLETED\`. The current survey should be
         * confirmed, we should register responses to the meta questions, and enter respondents, and lastly activate the survey.
         *
         * If there are no future surveys, and all existing surveys are completed, then there is no current survey and the
         * \`currentSurvey\` field will be \`NULL\`.
         */
        readonly currentSurvey?: Maybe<ProjectSurvey>;
        /** @deprecated Use subscription.discountCode */
        readonly discountCode?: Maybe<Scalars['String']['output']>;
        readonly id: Scalars['ID']['output'];
        readonly improvementBank?: Maybe<ImprovementBank>;
        /** @deprecated Use the improvementBank field */
        readonly improvementBankId?: Maybe<Scalars['ID']['output']>;
        readonly invoiceInformation: InvoiceInformation;
        /** The location of the project. It is at least required that a country is specified */
        readonly location?: Maybe<ProjectLocation>;
        readonly members: ReadonlyArray<ProjectTeamMember>;
        readonly name: Scalars['String']['output'];
        /**
         * Each project created in a team gets a sequential number. If a project
         * is deleted, there might be a gap, unless the project deleted is the
         * last project created.
         */
        readonly number?: Maybe<Scalars['Int']['output']>;
        readonly originalId: Scalars['String']['output'];
        /** @deprecated Use @rawId directive on teamId */
        readonly originalTeamId: Scalars['String']['output'];
        readonly path: Scalars['String']['output'];
        /** The date when the project was paused. Only available during when the status is PAUSED */
        readonly pausedAt?: Maybe<Scalars['DateTime']['output']>;
        /** The assigned portfolio is either a MainPortfolio (default) or a SubPortfolio */
        readonly portfolio: Portfolio;
        /** Based on a project budget, preview what the subscription would be (monthly cost, etc) */
        readonly previewSubscription: ProjectSubscription;
        readonly projectCategory?: Maybe<ProjectCategory>;
        readonly projectCategoryId?: Maybe<Scalars['ID']['output']>;
        readonly projectManager?: Maybe<User>;
        /** User who assigned the project manager */
        readonly projectManagerAssignedBy?: Maybe<User>;
        /** The project results is shared to these teams */
        readonly projectTeamShares: ReadonlyArray<ProjectTeamShare>;
        readonly questionnaire?: Maybe<QuestionnaireInterface>;
        /** @deprecated Use the questionnaire field */
        readonly questionnaireId?: Maybe<Scalars['ID']['output']>;
        readonly rawId: Scalars['String']['output'];
        /** Based on the project location, this is the recommended currency to use for the project budget */
        readonly recommendedCurrency?: Maybe<Scalars['String']['output']>;
        /** Based on the project location, this is the recommended locale to use for surveys and communication */
        readonly recommendedLocale?: Maybe<Scalars['LanguageTag']['output']>;
        readonly responsiblePerson?: Maybe<User>;
        readonly status: ProjectStatus;
        readonly subscription: ProjectSubscription;
        readonly survey?: Maybe<ProjectSurvey>;
        /**
         * User who is assigned to activate (configure and send) project surveys
         * @deprecated Use surveySender instead, basically the same thing
         */
        readonly surveyActivator?: Maybe<User>;
        /**
         * User who assigned the survey activator
         * @deprecated Use surveySenderAssignedBy instead, basically the same thing
         */
        readonly surveyActivatorAssignedBy?: Maybe<User>;
        readonly surveyCount: Scalars['Int']['output'];
        /** User who is assigned to plan the project surveys */
        readonly surveyPlanner?: Maybe<User>;
        /** User who assigned the survey planner */
        readonly surveyPlannerAssignedBy?: Maybe<User>;
        readonly surveySchedule: ProjectSurveySchedule;
        /** User who is assigned to configure and send project surveys */
        readonly surveySender?: Maybe<User>;
        /** User who assigned the survey sender */
        readonly surveySenderAssignedBy?: Maybe<User>;
        readonly surveys: ReadonlyArray<ProjectSurvey>;
        readonly team: Team;
        /** @deprecated Use the team field */
        readonly teamId: Scalars['ID']['output'];
        /** Based on the project location, this is the time zone for the project */
        readonly timeZone?: Maybe<Scalars['String']['output']>;
    };

export type ProjectPreviewSubscriptionArgs = {
    budget: MoneyInput;
};

export type ProjectQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type ProjectSurveyArgs = {
    surveyNumber: Scalars['Int']['input'];
};

export type ProjectBudget = {
    readonly __typename?: 'ProjectBudget';
    /** The amount is automatically exchanged to EUR, one of the default currencies. May not immediately be available */
    readonly EUR?: Maybe<Scalars['Int64']['output']>;
    /** The amount is automatically exchanged to SEK, one of the default currencies. May not immediately be available */
    readonly SEK?: Maybe<Scalars['Int64']['output']>;
    /** The amount is automatically exchanged to USD, one of the default currencies. May not immediately be available */
    readonly USD?: Maybe<Scalars['Int64']['output']>;
    /** The current project budget */
    readonly amount: Scalars['Int64']['output'];
    readonly correctnessLastCertifiedAt?: Maybe<Scalars['DateTime']['output']>;
    readonly correctnessLastCertifiedBy?: Maybe<User>;
    /**
     * The currency used to enter the budget. The currency code follows the 3-letter
     * standard described here: https://www.iban.com/currency-codes
     */
    readonly currency: Scalars['String']['output'];
    readonly isCorrectnessCertified: Scalars['Boolean']['output'];
};

export type ProjectCategory = {
    readonly __typename?: 'ProjectCategory';
    readonly description: Scalars['String']['output'];
    readonly id: Scalars['ID']['output'];
    readonly name: Scalars['String']['output'];
};

export type ProjectInterface = {
    readonly budget?: Maybe<ProjectBudget>;
    /** When was this project added */
    readonly createdAt: Scalars['DateTime']['output'];
    readonly id: Scalars['ID']['output'];
    /** The improvement bank assigned to this project */
    readonly improvementBank?: Maybe<ImprovementBank>;
    /** @deprecated Use the improvementBank field */
    readonly improvementBankId?: Maybe<Scalars['ID']['output']>;
    readonly location?: Maybe<ProjectLocation>;
    /** The official name of the project */
    readonly name: Scalars['String']['output'];
    /** @deprecated Use rawId (best for relay) or @rawId directive on id */
    readonly originalId: Scalars['String']['output'];
    /** A url-friendly path segment to the project */
    readonly path: Scalars['String']['output'];
    /** The assigned portfolio. It is either a MainPortfolio or a SubPortfolio */
    readonly portfolio: Portfolio;
    /** Optionally assign a category for the project */
    readonly projectCategory?: Maybe<ProjectCategory>;
    /**
     * User who is the project manager of this project
     * @deprecated Use responsiblePerson
     */
    readonly projectManager?: Maybe<User>;
    /**
     * This is a questionnaire just for this project. You can fetch it aggregated
     * which will include the team questionnaire as well as the PQi standard questionnaire
     */
    readonly questionnaire?: Maybe<QuestionnaireInterface>;
    /**
     * The questionnaire assigned to this project, where project specific questions can be added
     * @deprecated Use the questionnaire field
     */
    readonly questionnaireId?: Maybe<Scalars['ID']['output']>;
    readonly rawId: Scalars['String']['output'];
    /** Person responsible for the project. This is usually a project manager or other person in a leading role. */
    readonly responsiblePerson?: Maybe<User>;
    readonly status: ProjectStatus;
    /** Fetch a specific survey */
    readonly survey?: Maybe<ProjectSurvey>;
    /** The total number of surveys available in this project */
    readonly surveyCount: Scalars['Int']['output'];
    /** List all surveys available in the project */
    readonly surveys: ReadonlyArray<ProjectSurvey>;
    readonly team: Team;
};

export type ProjectInterfaceQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type ProjectInterfaceSurveyArgs = {
    surveyNumber: Scalars['Int']['input'];
};

export type ProjectLocation = {
    readonly __typename?: 'ProjectLocation';
    readonly address: Scalars['String']['output'];
    /**
     * Country-code used for calling international phone-numbers.
     *
     * Includes the "+" prefix. Example: "+46" for SE (sweden)
     */
    readonly countryCallingCode: Scalars['String']['output'];
    /** Two-letter ISO country-code */
    readonly countryCode: Scalars['String']['output'];
    readonly latitude: Scalars['Float']['output'];
    readonly longitude: Scalars['Float']['output'];
};

/** The current status of a project */
export enum ProjectStatus {
    /**
     * Project is completed. Once a project is completed, we will anonymize the survey recipients. It is possible to resume a
     * completed project, but not the anonymized data.
     */
    Completed = 'COMPLETED',
    /** The project is active */
    Ok = 'OK',
    /** Project is paused */
    Paused = 'PAUSED',
}

export type ProjectSubscription = {
    readonly __typename?: 'ProjectSubscription';
    readonly acceptedTermsAndConditions: Scalars['Boolean']['output'];
    /**
     * When was the project subscription activated? There is no way to manually activate a subscription, instead, once you
     * have accepted the terms and conditions, and a survey (usually the first survey) has been sent, the subscription is
     * automatically activated.
     */
    readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
    readonly cancellationOtherReason?: Maybe<Scalars['String']['output']>;
    readonly cancellationReason?: Maybe<ProjectSubscriptionCancellationReason>;
    /**
     * When a user requested to cancel the subscription. The subscription will automatically be deactivated once the
     * binding and notice period is over. Once cancelled, this field will be null again.
     */
    readonly cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
    /** When the subscription was cancelled. If the subscription is cancelled and later activated, this field will be null. */
    readonly cancelledAt?: Maybe<Scalars['DateTime']['output']>;
    readonly currency: Scalars['String']['output'];
    readonly discountCode?: Maybe<Scalars['String']['output']>;
    /** @deprecated You can use activatedAt !== null instead */
    readonly isActivated: Scalars['Boolean']['output'];
    readonly isDiscounted: Scalars['Boolean']['output'];
    /** This is the total monthly cost for the project with discounts applied */
    readonly monthlyCost: Scalars['Decimal']['output'];
    /**
     * If during an active subscription a project is paused, and later resumed, this contains the number of paused days.
     * While the project is paused, this number is not updated.
     */
    readonly pauseDurationDays: Scalars['Int']['output'];
    /** This is the matching price list entry for project budget */
    readonly priceListEntry: ProjectSubscriptionPriceListEntry;
};

export enum ProjectSubscriptionCancellationReason {
    Other = 'Other',
    ProjectCompleted = 'ProjectCompleted',
    ProjectPaused = 'ProjectPaused',
}

export type ProjectSubscriptionDiscountCode = {
    readonly __typename?: 'ProjectSubscriptionDiscountCode';
    readonly code: Scalars['String']['output'];
    readonly description?: Maybe<Scalars['String']['output']>;
    readonly discountAmount?: Maybe<Money>;
    readonly discountPercent?: Maybe<Scalars['Float']['output']>;
    /** The number of days that this discount applies */
    readonly discountPeriod?: Maybe<Scalars['Int']['output']>;
    /**
     * The maximum number of times that this discount code can be used. This really means the
     * number of projects that may use this code.
     */
    readonly maxUsageCount?: Maybe<Scalars['Int']['output']>;
    readonly teamId: Scalars['ID']['output'];
    /** In how many projects how this discount code been used. */
    readonly usageCount: Scalars['Int']['output'];
    /** If specified, this discount code cannot be applied in a project until this date. */
    readonly validFrom?: Maybe<Scalars['Date']['output']>;
    /** If specified, this code may only be applied in a project before this date. */
    readonly validUntil?: Maybe<Scalars['Date']['output']>;
};

export type ProjectSubscriptionDiscountCodeDescriptionArgs = {
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type ProjectSubscriptionDiscountCodeDiscountPeriodArgs = {
    projectBudget?: InputMaybe<MoneyInput>;
};

export type ProjectSubscriptionPriceList = {
    readonly __typename?: 'ProjectSubscriptionPriceList';
    readonly currency: Scalars['String']['output'];
    readonly customerSpecificInformation?: Maybe<Scalars['String']['output']>;
    readonly displayedProjectBudgetCurrency: Scalars['String']['output'];
    /** The price list entries are ordered from largest project budget down to the smallest */
    readonly entries: ReadonlyArray<ProjectSubscriptionPriceListEntry>;
    readonly isCustomerSpecific: Scalars['Boolean']['output'];
};

export type ProjectSubscriptionPriceListEntry = {
    readonly __typename?: 'ProjectSubscriptionPriceListEntry';
    /** In months */
    readonly bindingPeriod: Scalars['Int']['output'];
    readonly comment?: Maybe<Scalars['String']['output']>;
    /**
     * This discount is applied to the monthly cost and may come from certain industry connections or for other
     * reasons. The value here is a fraction, for example 0.1 = 10% discount.
     */
    readonly discount: Scalars['Float']['output'];
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.displayedProjectBudgetCurrency */
    readonly displayedMaximumProjectBudget: Scalars['String']['output'];
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.displayedProjectBudgetCurrency */
    readonly displayedMinimumProjectBudget: Scalars['String']['output'];
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.currency */
    readonly maximumProjectBudget?: Maybe<Scalars['Decimal']['output']>;
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.currency */
    readonly minimumProjectBudget: Scalars['Decimal']['output'];
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.currency */
    readonly monthlyCost: Scalars['Decimal']['output'];
    /** The currency used for this is defined here: ProjectSubscriptionPriceList.currency */
    readonly monthlyCostAfterDiscount: Scalars['Decimal']['output'];
    /** In months */
    readonly noticePeriod: Scalars['Int']['output'];
};

export type ProjectSurvey = Node & {
    readonly __typename?: 'ProjectSurvey';
    readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
    readonly createdAt: Scalars['DateTime']['output'];
    /** Was this survey created from a preliminary survey, or added directly */
    readonly createdFromPreliminary?: Maybe<Scalars['Boolean']['output']>;
    /** If sender is Custom, then you need to submit a value for this */
    readonly customSenderLineOne?: Maybe<Scalars['String']['output']>;
    /** If sender is Custom, then you may submit a value for this */
    readonly customSenderLineTwo?: Maybe<Scalars['String']['output']>;
    /**
     * Get the data sheet for this survey. Ongoing may have a sheet once there are responses, and
     * right now, it is updated once per hour.
     */
    readonly dataSheet?: Maybe<DataSheet>;
    /** Get data sheets meta groups */
    readonly dataSheetsMetaGroups: ReadonlyArray<DataSheetRespondentMetaGroupResult>;
    readonly endDate?: Maybe<Scalars['Date']['output']>;
    readonly id: Scalars['ID']['output'];
    /** @deprecated Use @rawId directive on id */
    readonly originalId: Scalars['String']['output'];
    /** @deprecated Use projectRawId or @rawId directive on projectId */
    readonly originalProjectId: Scalars['String']['output'];
    /** @deprecated Use recipientListRawId */
    readonly originalRecipientListId?: Maybe<Scalars['String']['output']>;
    /** Lists all previous surveys in descending order (the latest survey first) */
    readonly previousSurveys: ReadonlyArray<ProjectSurvey>;
    readonly projectId: Scalars['ID']['output'];
    readonly projectRawId: Scalars['String']['output'];
    readonly recipientList?: Maybe<RecipientList>;
    /**
     * A project survey needs a recipient list. The recipient list is part of the
     * questionnaire module, and handles all the respondents and survey meta. When
     * the survey is SCHEDULED - either by adding a new survey, or by confirming a
     * preliminary survey - a recipient list will be assigned.
     */
    readonly recipientListId?: Maybe<Scalars['ID']['output']>;
    readonly recipientListRawId?: Maybe<Scalars['String']['output']>;
    /** Are the complete results for survey unlocked? This happens when you buy a report. */
    readonly resultsUnlocked: Scalars['Boolean']['output'];
    /**
     * Who is the sender of notifications. The values for "sender", "customSenderLineOne" and "customSenderLineTwo" is also
     * found when you inspect the recipientList.textReplacements
     */
    readonly sender?: Maybe<ProjectSurveySender>;
    /** The exact time that the survey invitation was sent. */
    readonly sentAt?: Maybe<Scalars['DateTime']['output']>;
    readonly status: ProjectSurveyStatus;
    readonly surveyDate: Scalars['Date']['output'];
    readonly surveyNumber: Scalars['Int']['output'];
    /**
     * The survey template, if any, that was selected for this survey. Please note that
     * this may refer to a deleted survey template. You will have to fetch all templates
     * available for the Team.
     */
    readonly surveyTemplate?: Maybe<ProjectSurveyTemplate>;
    readonly surveyTemplateId?: Maybe<Scalars['ID']['output']>;
    readonly timeOfDay?: Maybe<Scalars['String']['output']>;
    readonly timeZone?: Maybe<Scalars['String']['output']>;
};

export type ProjectSurveyClosedError = Error & {
    readonly __typename?: 'ProjectSurveyClosedError';
    readonly message: Scalars['String']['output'];
    readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
    readonly survey: ProjectSurvey;
};

export type ProjectSurveyDataSheetFilterInput = {
    /** Only fetch results for the specified indicators (recommended, can be combined with questionIds) */
    readonly indicatorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /** Only fetch results for the specified questions (recommended, can be combined with indicatorIds) */
    readonly questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
    /** Limit the results to respondents with the specified respondent meta responses */
    readonly respondentMetaFilter?: InputMaybe<
        ReadonlyArray<DataSheetFilterMetaQuestionInput>
    >;
};

export type ProjectSurveyEndsBeforeStartError = Error & {
    readonly __typename?: 'ProjectSurveyEndsBeforeStartError';
    readonly message: Scalars['String']['output'];
    readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
    readonly survey: ProjectSurvey;
};

export type ProjectSurveyEndsBeforeTodayError = Error & {
    readonly __typename?: 'ProjectSurveyEndsBeforeTodayError';
    readonly message: Scalars['String']['output'];
    readonly path?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
    readonly survey: ProjectSurvey;
};

export type ProjectSurveyFilterInput = {
    /**
     * Limit the results to surveys from your projects only. A project is considered "my project" if you are a member
     * of that project.
     */
    readonly onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
    /** Limit results surveys with the specified statuses */
    readonly status?: InputMaybe<ReadonlyArray<ProjectSurveyStatus>>;
};

export type ProjectSurveyRecipientListSurveyMetaInput = {
    readonly metaQuestionId: Scalars['ID']['input'];
    readonly noOpinion?: InputMaybe<Scalars['Boolean']['input']>;
    readonly responseOptionValue?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSurveyResult = {
    readonly __typename?: 'ProjectSurveyResult';
    readonly answerCount: Scalars['Int']['output'];
    readonly commentCount?: Maybe<Scalars['Int']['output']>;
    readonly improve?: Maybe<Scalars['Float']['output']>;
    readonly indicatorId?: Maybe<Scalars['ID']['output']>;
    readonly negativeShare?: Maybe<Scalars['Float']['output']>;
    readonly neutralShare?: Maybe<Scalars['Float']['output']>;
    readonly noOpinion?: Maybe<Scalars['Float']['output']>;
    readonly originalIndicatorId?: Maybe<Scalars['ID']['output']>;
    readonly originalQuestionId?: Maybe<Scalars['ID']['output']>;
    readonly positiveShare?: Maybe<Scalars['Float']['output']>;
    readonly questionId?: Maybe<Scalars['ID']['output']>;
    readonly rating?: Maybe<Scalars['Float']['output']>;
    readonly responseCount: Scalars['Int']['output'];
};

export type ProjectSurveySchedule = {
    readonly __typename?: 'ProjectSurveySchedule';
    readonly dates: ReadonlyArray<Scalars['Date']['output']>;
};

/** Who is the sender of notifications */
export enum ProjectSurveySender {
    /** The sender will be custom, using customSenderLineOne and customSenderLineTwo */
    Custom = 'CUSTOM',
    /** The sender will be the project management */
    ProjectManagement = 'PROJECT_MANAGEMENT',
    /** The sender will be the project manager (name and rol) */
    ProjectManager = 'PROJECT_MANAGER',
}

export enum ProjectSurveyStatus {
    Activated = 'ACTIVATED',
    BehindPreliminarySchedule = 'BEHIND_PRELIMINARY_SCHEDULE',
    BehindSchedule = 'BEHIND_SCHEDULE',
    Completed = 'COMPLETED',
    Ongoing = 'ONGOING',
    Preliminary = 'PRELIMINARY',
    Scheduled = 'SCHEDULED',
}

export type ProjectSurveyTemplate = {
    readonly __typename?: 'ProjectSurveyTemplate';
    /** A short description, such as "Use this for all projects less than 10 MSEK" */
    readonly description: Scalars['String']['output'];
    readonly id: Scalars['ID']['output'];
    /** A short descriptive name, such as "Small projects" */
    readonly name: Scalars['String']['output'];
    readonly questionFilters: ReadonlyArray<ProjectSurveyTemplateQuestionFilter>;
    /** Please note that this id matches Question.originalId */
    readonly questionIds: ReadonlyArray<Scalars['String']['output']>;
};

export type ProjectSurveyTemplateMutationPayload = {
    readonly __typename?: 'ProjectSurveyTemplateMutationPayload';
    readonly projectSurveyTemplate?: Maybe<ProjectSurveyTemplate>;
    readonly team?: Maybe<Team>;
};

export type ProjectSurveyTemplateQuestionFilter = {
    readonly __typename?: 'ProjectSurveyTemplateQuestionFilter';
    readonly filterGroups: ReadonlyArray<
        Maybe<ProjectSurveyTemplateQuestionFilterGroup>
    >;
    /** Matches the content of Question.originalId */
    readonly questionId: Scalars['String']['output'];
};

export type ProjectSurveyTemplateQuestionFilterGroup = {
    readonly __typename?: 'ProjectSurveyTemplateQuestionFilterGroup';
    readonly filters: ReadonlyArray<ProjectSurveyTemplateQuestionResponseOptionSelection>;
};

export type ProjectSurveyTemplateQuestionFilterGroupInput = {
    readonly filters: ReadonlyArray<ProjectSurveyTemplateQuestionResponseOptionSelectionInput>;
};

export type ProjectSurveyTemplateQuestionFilterInput = {
    readonly filterGroups: ReadonlyArray<ProjectSurveyTemplateQuestionFilterGroupInput>;
    readonly questionId: Scalars['String']['input'];
};

export type ProjectSurveyTemplateQuestionResponseOptionSelection = {
    readonly __typename?: 'ProjectSurveyTemplateQuestionResponseOptionSelection';
    /** Matches the content of Question.originalId */
    readonly questionId: Scalars['String']['output'];
    readonly responseOptionValues: ReadonlyArray<Scalars['Int']['output']>;
};

export type ProjectSurveyTemplateQuestionResponseOptionSelectionInput = {
    readonly questionId: Scalars['String']['input'];
    readonly responseOptionValues: ReadonlyArray<Scalars['Int']['input']>;
};

export type ProjectSurveyTrend = {
    readonly __typename?: 'ProjectSurveyTrend';
    readonly dataPoints: ReadonlyArray<ProjectSurveyTrendDataPoint>;
    readonly indicatorId?: Maybe<Scalars['ID']['output']>;
    readonly latestDataPoint?: Maybe<ProjectSurveyTrendDataPoint>;
    readonly originalIndicatorId?: Maybe<Scalars['String']['output']>;
    readonly originalQuestionId?: Maybe<Scalars['String']['output']>;
    readonly questionId?: Maybe<Scalars['ID']['output']>;
};

export type ProjectSurveyTrendDataPoint = {
    readonly __typename?: 'ProjectSurveyTrendDataPoint';
    readonly date: Scalars['Date']['output'];
    readonly rating?: Maybe<Scalars['Float']['output']>;
    readonly ratingMovingAverage?: Maybe<Scalars['Float']['output']>;
};

export type ProjectTeamMember = {
    readonly __typename?: 'ProjectTeamMember';
    readonly id: Scalars['ID']['output'];
    readonly roles: ReadonlyArray<ProjectTeamMemberRoleName>;
    /**
     * Should the project team member receive notifications about survey activity?
     * ProjectSurveyStarted
     * ProjectSurveyOngoing - Sent one day after a reminder is sent with information about the current response rate
     * ProjectSurveyCompleted
     */
    readonly surveyNotifications: Scalars['Boolean']['output'];
    readonly user: User;
};

export enum ProjectTeamMemberRoleName {
    /** @deprecated Use SURVEY_ADMIN */
    ProjectManager = 'PROJECT_MANAGER',
    /** Only results */
    ResultsViewer = 'RESULTS_VIEWER',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyActivator = 'SURVEY_ACTIVATOR',
    /** Full access */
    SurveyAdmin = 'SURVEY_ADMIN',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyAdministrator = 'SURVEY_ADMINISTRATOR',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyPlanner = 'SURVEY_PLANNER',
}

/**
 * What information is shared from the project?
 *
 * The project name, responsible person and team basic information is always shared with the receiving team.
 * Besides that, you can control which surveys are shared, and if future surveys should be automatically shared.
 * You can also select if project custom questions and team custom questions should be shared.
 */
export type ProjectTeamShare = {
    readonly __typename?: 'ProjectTeamShare';
    /** If enabled, all future surveys will be automatically shared */
    readonly futureSurveys: Scalars['Boolean']['output'];
    readonly id: Scalars['ID']['output'];
    /** If enabled, results from project custom question will be shared */
    readonly shareProjectQuestions: Scalars['Boolean']['output'];
    /** If enabled, results from team custom question will be shared */
    readonly shareTeamQuestions: Scalars['Boolean']['output'];
    /** Results from these surveys will be shared */
    readonly surveyNumbers: ReadonlyArray<Scalars['Int']['output']>;
    /** This is the team that we are sharing the project with */
    readonly team: TeamBasicInfo;
};

export type Query = {
    readonly __typename?: 'Query';
    readonly areaOfImprovementBySlug?: Maybe<AreaOfImprovement>;
    /** Make a data sheet selection */
    readonly dataSheetSelection: DataSheetSelection;
    /** Get data sheets */
    readonly dataSheets: ReadonlyArray<DataSheet>;
    /** Get data sheets meta */
    readonly dataSheetsMetaGroups: ReadonlyArray<DataSheetRespondentMetaGroupResult>;
    readonly discussion?: Maybe<Discussion>;
    readonly exportRawData?: Maybe<DownloadInfo>;
    /**
     * Finds teams based on that their name start with a certain string. it requires that
     * the 3 first characters match.
     *
     * Only teams that opt-in to receive shared projects are listed here.
     */
    readonly findTeamBasicInfo?: Maybe<FindTeamBasicInfoResult>;
    readonly improvementBank?: Maybe<ImprovementBank>;
    readonly improvementBankForProject?: Maybe<ImprovementBank>;
    /** The languageName and territoryName are presented in this locale if the argument is present */
    readonly locale: LocaleInfo;
    /** The languageName and territoryName are presented in this locale if the argument is present */
    readonly locales: ReadonlyArray<LocaleInfo>;
    /** Gets information about you, the authenticated user */
    readonly me?: Maybe<User>;
    readonly metaResults: ReadonlyArray<MetaResult>;
    /** Fetches an object given its ID */
    readonly node?: Maybe<Node>;
    /** Fetches objects given their IDs */
    readonly nodes: ReadonlyArray<Maybe<Node>>;
    /** Get information about a PQi user. If not id is provided, information about the currently authenticated user is requested */
    readonly pqiUser?: Maybe<PQiUser>;
    /** Get a project by ID */
    readonly project?: Maybe<ProjectInterface>;
    /** Get a project by path */
    readonly projectByPath?: Maybe<ProjectInterface>;
    /** Get aggregated project survey results */
    readonly projectSurveyResults: ReadonlyArray<ProjectSurveyResult>;
    /** Get aggregated project survey trend */
    readonly projectSurveyTrend: ReadonlyArray<ProjectSurveyTrend>;
    readonly questionComments: ReadonlyArray<Scalars['String']['output']>;
    readonly questionCommentsExtended: ReadonlyArray<QuestionComment>;
    readonly questionnaire?: Maybe<QuestionnaireInterface>;
    readonly questionnaireReferenceData?: Maybe<QuestionnaireReferenceData>;
    readonly questionnaireTranslation?: Maybe<QuestionnaireTranslation>;
    readonly recipientList?: Maybe<RecipientList>;
    readonly recipientListSurveyCode?: Maybe<RecipientListSurveyCode>;
    readonly respondent?: Maybe<Respondent>;
    readonly results: ReadonlyArray<Result>;
    /** Get a team by ID */
    readonly team?: Maybe<Team>;
    readonly teamByPath?: Maybe<Team>;
    /** List my teams */
    readonly teams: ReadonlyArray<Team>;
    readonly userSettings?: Maybe<UserSettings>;
    readonly viewer?: Maybe<Viewer>;
};

export type QueryAreaOfImprovementBySlugArgs = {
    improvementBankId: Scalars['ID']['input'];
    slug: Scalars['String']['input'];
};

export type QueryDataSheetSelectionArgs = {
    dataSheetFilter: DataSheetFilterInput;
};

export type QueryDataSheetsArgs = {
    dataSheetFilter: DataSheetFilterInput;
};

export type QueryDataSheetsMetaGroupsArgs = {
    dataSheetFilter: DataSheetFilterInput;
};

export type QueryDiscussionArgs = {
    id: Scalars['ID']['input'];
};

export type QueryExportRawDataArgs = {
    columnFilters?: InputMaybe<ReadonlyArray<RawDataColumnFilter>>;
    format?: InputMaybe<RawDataFormat>;
    questionnaireId: Scalars['ID']['input'];
    textReplacementFields?: InputMaybe<
        ReadonlyArray<Scalars['String']['input']>
    >;
};

export type QueryFindTeamBasicInfoArgs = {
    nameStartsWith: Scalars['String']['input'];
};

export type QueryImprovementBankArgs = {
    improvementBankId: Scalars['ID']['input'];
};

export type QueryImprovementBankForProjectArgs = {
    projectId: Scalars['ID']['input'];
};

export type QueryLocaleArgs = {
    id: Scalars['String']['input'];
    inLocaleId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLocalesArgs = {
    ids: ReadonlyArray<Scalars['String']['input']>;
    inLocaleId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMetaResultsArgs = {
    filters?: InputMaybe<ReadonlyArray<ResultFilter>>;
    questionnaireId: Scalars['ID']['input'];
};

export type QueryNodeArgs = {
    id: Scalars['ID']['input'];
};

export type QueryNodesArgs = {
    ids: ReadonlyArray<Scalars['ID']['input']>;
};

export type QueryPqiUserArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryProjectArgs = {
    id: Scalars['ID']['input'];
};

export type QueryProjectByPathArgs = {
    projectPath: Scalars['String']['input'];
    teamPath: Scalars['String']['input'];
};

export type QueryProjectSurveyResultsArgs = {
    dataSheetFilter: DataSheetFilterInput;
};

export type QueryProjectSurveyTrendArgs = {
    dataSheetFilter: DataSheetFilterInput;
    movingAverageWindow?: Scalars['Int']['input'];
};

export type QueryQuestionCommentsArgs = {
    filters?: InputMaybe<ReadonlyArray<ResultFilter>>;
    questionId: Scalars['ID']['input'];
    questionnaireId: Scalars['ID']['input'];
};

export type QueryQuestionCommentsExtendedArgs = {
    filters?: InputMaybe<ReadonlyArray<ResultFilter>>;
    questionId: Scalars['ID']['input'];
    questionnaireId: Scalars['ID']['input'];
};

export type QueryQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['ID']['input'];
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryQuestionnaireReferenceDataArgs = {
    name: Scalars['String']['input'];
    questionnaireId: Scalars['ID']['input'];
};

export type QueryQuestionnaireTranslationArgs = {
    locale: Scalars['LanguageTag']['input'];
    questionnaireId: Scalars['ID']['input'];
};

export type QueryRecipientListArgs = {
    id: Scalars['ID']['input'];
};

export type QueryRecipientListSurveyCodeArgs = {
    surveyCode: Scalars['String']['input'];
};

export type QueryRespondentArgs = {
    respondentId: Scalars['ID']['input'];
};

export type QueryResultsArgs = {
    filters?: InputMaybe<ReadonlyArray<ResultFilter>>;
    percentileRanks?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
    questionnaireId: Scalars['ID']['input'];
};

export type QueryTeamArgs = {
    id: Scalars['ID']['input'];
};

export type QueryTeamByPathArgs = {
    path: Scalars['String']['input'];
};

export type QueryUserSettingsArgs = {
    userId: Scalars['String']['input'];
};

export type Question = {
    readonly __typename?: 'Question';
    /** A customized improve question, if you dont want to use the standard for the questionnaire */
    readonly customImproveQuestion?: Maybe<Scalars['String']['output']>;
    /**
     * Some questions may need an additional explanatory text.
     *
     * You may use the <strong>, <em>, <details> and <summary> html tags as well as
     * **strong** or _emphased_ text in markdown flavour
     */
    readonly explanatoryText?: Maybe<Scalars['String']['output']>;
    /**
     * The full form question. This is the question that we ask the respondents.
     *
     * You may use the <strong> and <em> html tags as well as **strong** or _emphased_ text in markdown flavour
     */
    readonly fullForm: Scalars['String']['output'];
    /** A comment field will be available for the respondent */
    readonly hasCommentField?: Maybe<Scalars['Boolean']['output']>;
    /** A question if improvement is needed or not will be available for the respondent */
    readonly hasImproveQuestion?: Maybe<Scalars['Boolean']['output']>;
    /** An option will be available for the respondent so select "no opinion" */
    readonly hasNoOpinion?: Maybe<Scalars['Boolean']['output']>;
    readonly id: Scalars['ID']['output'];
    /**
     * When you add a new question, you may optionally put it in draft mode. This means that
     * the question will not be available in surveys until you update isDraft to true.
     *
     * This is only supported for NEW questions at the moment. Any EDITS made to an existing question
     * are immediate. It is also not possible to set isDraft to true again for an existing question. In
     * the future we might add a system where you publish your changes instead of just updating a prop.
     */
    readonly isDraft?: Maybe<Scalars['Boolean']['output']>;
    /**
     * This question is hidden and should not be displayed to the respondent. It is still
     * possible to pre-register a response to this question.
     */
    readonly isHidden?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The question is used as meta-data to describe the respondent or what is being measured.
     * The main purpose of meta question is to filter respondents when aggregating results.
     */
    readonly isMeta?: Maybe<Scalars['Boolean']['output']>;
    /**
     * This question is used as survey meta data, which means that the response to the question
     * is registered on the recipient list and applies to all respondents.
     * The main purpose of meta question is to filter respondents when aggregating results.
     */
    readonly isSurveyMeta?: Maybe<Scalars['Boolean']['output']>;
    /** An IEFT language tag */
    readonly locale: Scalars['LanguageTag']['output'];
    /**
     * True if this question in the question.locale is in need of translation. There might be a full form and short form, but
     * for the wrong language.
     */
    readonly needsTranslation: Scalars['Boolean']['output'];
    /** Original id without any magic */
    readonly originalId: Scalars['String']['output'];
    readonly originalResponseScaleId?: Maybe<Scalars['String']['output']>;
    readonly originalVisibilityConditionId?: Maybe<Scalars['String']['output']>;
    /** A path to be used in URL's. If the path is not implicitly defined, the question id will be used */
    readonly path: Scalars['String']['output'];
    /**
     * If the question is a single-choice, multi-choice or rating question, there must be a response scale
     *
     * Depending on the use case, you might want to access the ResponseScale directly, instead us using the id
     * to lookup the response scale. Mind though that many questions may use the same response scale.
     */
    readonly responseScale?: Maybe<ResponseScale>;
    /** If the question is a single-choice, multi-choice or rating question, there must be a response scale */
    readonly responseScaleId?: Maybe<Scalars['ID']['output']>;
    /** The short form question. This may be used in situations where the full form question is too long. */
    readonly shortForm?: Maybe<Scalars['String']['output']>;
    /** A list of tags that can be used to describe the question */
    readonly tags: ReadonlyArray<Scalars['String']['output']>;
    readonly translation?: Maybe<QuestionTranslation>;
    readonly translations: ReadonlyArray<QuestionTranslation>;
    readonly type: QuestionType;
    /**
     * List of locales that does not yet have a translation for this question. The list is based on the
     * list of available locales for this questionnaire (not a parent questionnaire)
     */
    readonly untranslatedLocales: ReadonlyArray<
        Scalars['LanguageTag']['output']
    >;
    /**
     * If there is a visibility condition assigned to the question, it's visibility is
     * determined by evaluating the rules and expression of the visibility condition
     *
     * Depending on the use case, you might want to access the VisibilityCondition directly, instead of using the id
     * to lookup the visibility condition. Mind though that many questions may use the same visibility condition.
     */
    readonly visibilityCondition?: Maybe<VisibilityCondition>;
    /**
     * If there is a visibility condition assigned to the question, it's visibility is
     * determined by evaluating the rules and expression of the visibility condition
     */
    readonly visibilityConditionId?: Maybe<Scalars['ID']['output']>;
};

export type QuestionTranslationArgs = {
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type QuestionBestPractice = BestPractice & {
    readonly __typename?: 'QuestionBestPractice';
    readonly P10: Scalars['Float']['output'];
    readonly P25: Scalars['Float']['output'];
    readonly P75: Scalars['Float']['output'];
    readonly P90: Scalars['Float']['output'];
    readonly originalQuestionId: Scalars['String']['output'];
    readonly questionId: Scalars['ID']['output'];
};

export type QuestionComment = {
    readonly __typename?: 'QuestionComment';
    readonly comment: Scalars['String']['output'];
    readonly originalQuestionId: Scalars['ID']['output'];
    readonly questionId: Scalars['ID']['output'];
    readonly respondent: Respondent;
};

export type QuestionFilterInput = {
    /**
     * Normally, questions in draft are not included, unless you specify that you also need the drafts.
     * By Draft, we mean questions that are new, and not yet added to the questionnaire. There is not
     * yet a system in place to put an existing question in draft mode.
     */
    readonly includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Here we can select questions that are only meta questions, or questions that specifically are
     * not meta questions.
     */
    readonly isMeta?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Here we can select questions that are only survey meta questions, or questions that specifically are
     * not survey meta questions.
     */
    readonly isSurveyMeta?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionResponse = {
    readonly __typename?: 'QuestionResponse';
    readonly comment?: Maybe<Scalars['String']['output']>;
    readonly improve?: Maybe<Scalars['Boolean']['output']>;
    /** True if this is a pre-registered meta question response */
    readonly isPreRegisteredMeta?: Maybe<Scalars['Boolean']['output']>;
    readonly noOpinion?: Maybe<Scalars['Boolean']['output']>;
    readonly originalQuestionId: Scalars['String']['output'];
    readonly questionId: Scalars['ID']['output'];
    readonly selectedResponseOptions: ReadonlyArray<ResponseOptionResponse>;
};

export type QuestionResponseInput = {
    readonly comment?: InputMaybe<Scalars['String']['input']>;
    readonly improve?: InputMaybe<Scalars['Boolean']['input']>;
    readonly noOpinion?: InputMaybe<Scalars['Boolean']['input']>;
    readonly questionId: Scalars['ID']['input'];
    readonly selectedResponseOptions?: InputMaybe<
        ReadonlyArray<ResponseOptionResponseInput>
    >;
};

export type QuestionResult = Result & {
    readonly __typename?: 'QuestionResult';
    readonly anonymous: Scalars['Boolean']['output'];
    readonly answerCount: Scalars['Int']['output'];
    readonly commentCount?: Maybe<Scalars['Int']['output']>;
    readonly commentPercent?: Maybe<Scalars['Int']['output']>;
    readonly improveCount?: Maybe<Scalars['Int']['output']>;
    readonly improvePercent?: Maybe<Scalars['Float']['output']>;
    readonly noOpinionCount?: Maybe<Scalars['Int']['output']>;
    readonly noOpinionPercent?: Maybe<Scalars['Float']['output']>;
    readonly originalQuestionId: Scalars['String']['output'];
    readonly percentiles?: Maybe<ReadonlyArray<PercentileResult>>;
    readonly questionId: Scalars['ID']['output'];
    readonly responseCount: Scalars['Int']['output'];
    readonly responseScaleResult?: Maybe<ResponseScaleResult>;
    readonly resultType: ResultType;
};

export type QuestionTranslation = {
    readonly __typename?: 'QuestionTranslation';
    readonly fullForm?: Maybe<Scalars['String']['output']>;
    /** The ID of the translation, which is a combination of question id and locale */
    readonly id: Scalars['ID']['output'];
    /** An IEFT language tag */
    readonly locale: Scalars['LanguageTag']['output'];
    readonly needsTranslation: Scalars['Boolean']['output'];
    readonly originalQuestionId: Scalars['String']['output'];
    readonly questionId: Scalars['ID']['output'];
    readonly shortForm?: Maybe<Scalars['String']['output']>;
};

export enum QuestionType {
    MultiChoice = 'MULTI_CHOICE',
    OpenEnded = 'OPEN_ENDED',
    Rating = 'RATING',
    SingleChoice = 'SINGLE_CHOICE',
}

export type QuestionVisibilityCondition = {
    readonly __typename?: 'QuestionVisibilityCondition';
    readonly originalQuestionId: Scalars['String']['output'];
    readonly questionId: Scalars['ID']['output'];
    readonly visibilityCondition: BasicVisibilityCondition;
};

export type QuestionVisibilityConditionInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly visibilityCondition?: InputMaybe<VisibilityConditionInput>;
};

export type Questionnaire = QuestionnaireInterface & {
    readonly __typename?: 'Questionnaire';
    readonly availableLocales: ReadonlyArray<Scalars['LanguageTag']['output']>;
    /** @deprecated Use the tools available in your programming language */
    readonly availableLocalesInfo: ReadonlyArray<LocaleInfo>;
    readonly id: Scalars['ID']['output'];
    readonly indicators: ReadonlyArray<Indicator>;
    readonly locale: Scalars['LanguageTag']['output'];
    /** @deprecated Use the tools available in your programming language */
    readonly localeInfo: LocaleInfo;
    readonly name?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use rawId */
    readonly originalId: Scalars['String']['output'];
    readonly parentId?: Maybe<Scalars['ID']['output']>;
    readonly parentVersion?: Maybe<Scalars['Int']['output']>;
    /** A single question. The question index is 0-based. */
    readonly questionByIndex?: Maybe<Question>;
    readonly questions: ReadonlyArray<Question>;
    readonly rawId: Scalars['String']['output'];
    readonly referenceData?: Maybe<QuestionnaireReferenceData>;
    readonly responseScales: ReadonlyArray<ResponseScale>;
    readonly sections: ReadonlyArray<Section>;
    readonly standardTexts: ReadonlyArray<StandardText>;
    readonly textReplacements: ReadonlyArray<TextReplacement>;
    readonly translation?: Maybe<QuestionnaireTranslation>;
    readonly translations: ReadonlyArray<QuestionnaireTranslation>;
    readonly version: Scalars['Int']['output'];
    readonly visibilityConditions: ReadonlyArray<VisibilityCondition>;
};

export type QuestionnaireAvailableLocalesInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type QuestionnaireLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type QuestionnaireQuestionByIndexArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
    questionIndex: Scalars['Int']['input'];
};

export type QuestionnaireQuestionsArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
};

export type QuestionnaireReferenceDataArgs = {
    name: Scalars['String']['input'];
};

export type QuestionnaireStandardTextsArgs = {
    prefix?: InputMaybe<Scalars['String']['input']>;
    types?: InputMaybe<ReadonlyArray<StandardTextType>>;
};

export type QuestionnaireTranslationArgs = {
    locale: Scalars['LanguageTag']['input'];
};

export type QuestionnaireInterface = {
    /** List the locales that this questionnaire is available for */
    readonly availableLocales: ReadonlyArray<Scalars['LanguageTag']['output']>;
    /**
     * List the locales that this questionnaire is available for
     * @deprecated Use the tools available in your programming language (such as Intl)
     */
    readonly availableLocalesInfo: ReadonlyArray<LocaleInfo>;
    /**
     * When the header X-Binosight-Use-Versioned-Questionnaire-Ids equals "true", the questionnaire version is
     * used to make the id unique for a specific version of the questionnaire.
     *
     * Note:
     * Locale is currently not part of the id, but there might be some added benefits of doing so, if you
     * are using relay. There might also be some downsides.
     */
    readonly id: Scalars['ID']['output'];
    readonly indicators: ReadonlyArray<Indicator>;
    readonly locale: Scalars['LanguageTag']['output'];
    /** @deprecated Use the tools available in your programming language (such as Intl) */
    readonly localeInfo: LocaleInfo;
    readonly name?: Maybe<Scalars['String']['output']>;
    /**
     * Original id without any magic
     * @deprecated Use rawId
     */
    readonly originalId: Scalars['String']['output'];
    /** Lists all questions in this questionnaire */
    readonly questions: ReadonlyArray<Question>;
    readonly rawId: Scalars['String']['output'];
    /** The questionnaire may have different named reference values. The type of values store is application specific */
    readonly referenceData?: Maybe<QuestionnaireReferenceData>;
    readonly responseScales: ReadonlyArray<ResponseScale>;
    readonly sections: ReadonlyArray<Section>;
    readonly standardTexts: ReadonlyArray<StandardText>;
    readonly textReplacements: ReadonlyArray<TextReplacement>;
    readonly version: Scalars['Int']['output'];
    readonly visibilityConditions: ReadonlyArray<VisibilityCondition>;
};

export type QuestionnaireInterfaceAvailableLocalesInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type QuestionnaireInterfaceLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type QuestionnaireInterfaceQuestionsArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
};

export type QuestionnaireInterfaceReferenceDataArgs = {
    name: Scalars['String']['input'];
};

export type QuestionnaireInterfaceStandardTextsArgs = {
    prefix?: InputMaybe<Scalars['String']['input']>;
    types?: InputMaybe<ReadonlyArray<StandardTextType>>;
};

export type QuestionnaireReferenceData = {
    readonly __typename?: 'QuestionnaireReferenceData';
    readonly data: ReadonlyArray<QuestionnaireReferenceDataEntry>;
    readonly name: Scalars['String']['output'];
    readonly originalQuestionnaireId: Scalars['String']['output'];
    readonly questionnaireId: Scalars['ID']['output'];
    readonly valueKeys: ReadonlyArray<Scalars['String']['output']>;
    readonly version: Scalars['String']['output'];
};

export type QuestionnaireReferenceDataEntry = {
    readonly __typename?: 'QuestionnaireReferenceDataEntry';
    readonly indicatorId?: Maybe<Scalars['String']['output']>;
    readonly indicatorKey?: Maybe<Scalars['String']['output']>;
    readonly originalIndicatorId?: Maybe<Scalars['String']['output']>;
    readonly originalQuestionId?: Maybe<Scalars['String']['output']>;
    readonly questionId?: Maybe<Scalars['String']['output']>;
    readonly values: ReadonlyArray<Maybe<Scalars['Float']['output']>>;
};

export type QuestionnaireTranslation = {
    readonly __typename?: 'QuestionnaireTranslation';
    readonly id: Scalars['ID']['output'];
    readonly indicatorTranslations: ReadonlyArray<IndicatorTranslation>;
    readonly instructions?: Maybe<Scalars['String']['output']>;
    readonly locale: Scalars['LanguageTag']['output'];
    readonly localeInfo: LocaleInfo;
    readonly name?: Maybe<Scalars['String']['output']>;
    readonly nextQuestionButtonLabel?: Maybe<Scalars['String']['output']>;
    readonly questionTranslations: ReadonlyArray<QuestionTranslation>;
    readonly questionnaireId: Scalars['String']['output'];
    readonly respondentConsentStatement?: Maybe<Scalars['String']['output']>;
    readonly responseScalesTranslations: ReadonlyArray<ResponseScaleTranslation>;
    readonly sectionDividerText?: Maybe<Scalars['String']['output']>;
    readonly sectionTranslations: ReadonlyArray<SectionTranslation>;
    readonly startButtonLabel?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireTranslationLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** Filter rawdata rows */
export type RawDataColumnFilter = {
    /** Also require this column to match */
    readonly and?: InputMaybe<RawDataColumnFilter>;
    /** This is the column name, it is case sensitive. */
    readonly columnName: Scalars['String']['input'];
    /** Matches any of these values in the column. If the array is empty, the filter is ignored */
    readonly values: ReadonlyArray<Scalars['String']['input']>;
};

export enum RawDataFormat {
    Csv = 'Csv',
    Json = 'Json',
}

export type RecallProjectSubscriptionCancellationRequestInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type RecallProjectSubscriptionCancellationRequestPayload = {
    readonly __typename?: 'RecallProjectSubscriptionCancellationRequestPayload';
    readonly project?: Maybe<Project>;
};

export type ReceivedProject = Node &
    ProjectInterface & {
        readonly __typename?: 'ReceivedProject';
        readonly budget?: Maybe<ProjectBudget>;
        /** This is the time that the project was shared/received */
        readonly createdAt: Scalars['DateTime']['output'];
        /** Are custom project questions shared? */
        readonly customProjectQuestionsIncluded: Scalars['Boolean']['output'];
        /** Are custom team questions shared? */
        readonly customTeamQuestionsIncluded: Scalars['Boolean']['output'];
        readonly id: Scalars['ID']['output'];
        readonly improvementBank?: Maybe<ImprovementBank>;
        /** @deprecated Use the improvementBank field */
        readonly improvementBankId?: Maybe<Scalars['ID']['output']>;
        readonly location?: Maybe<ProjectLocation>;
        readonly name: Scalars['String']['output'];
        /** @deprecated Use rawId (best for relay) or @rawId directive on id */
        readonly originalId: Scalars['String']['output'];
        readonly path: Scalars['String']['output'];
        readonly portfolio: Portfolio;
        readonly projectCategory?: Maybe<ProjectCategory>;
        /** @deprecated Use responsiblePerson */
        readonly projectManager?: Maybe<User>;
        readonly questionnaire?: Maybe<QuestionnaireInterface>;
        /** @deprecated Use the questionnaire field */
        readonly questionnaireId?: Maybe<Scalars['ID']['output']>;
        readonly rawId: Scalars['String']['output'];
        readonly responsiblePerson?: Maybe<User>;
        readonly sharedProjectDetails: SharedProjectDetails;
        readonly status: ProjectStatus;
        readonly survey?: Maybe<ProjectSurvey>;
        readonly surveyCount: Scalars['Int']['output'];
        readonly surveys: ReadonlyArray<ProjectSurvey>;
        readonly team: Team;
    };

export type ReceivedProjectQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type ReceivedProjectSurveyArgs = {
    surveyNumber: Scalars['Int']['input'];
};

export type Recipient = {
    readonly __typename?: 'Recipient';
    readonly emailAddress?: Maybe<Scalars['String']['output']>;
    readonly metaQuestionResponses: ReadonlyArray<QuestionResponse>;
    readonly phoneNumber?: Maybe<Scalars['String']['output']>;
    /**
     * This is really just a convenient shortcut to retrieve just the pre-registered meta question responses for
     * each respondent.
     */
    readonly preRegisteredMetaQuestionResponses: ReadonlyArray<QuestionResponse>;
    readonly respondentId: Scalars['ID']['output'];
    /** Beta version of a status field for the recipient. */
    readonly status_beta?: Maybe<RecipientStatus>;
    readonly type: RecipientType;
};

export type RecipientList = Node & {
    readonly __typename?: 'RecipientList';
    /**
     * Fetches the correct version of the aggregated questionnaire with customizations applied
     *
     * NOTE:
     * When customized, the questionnaire id made up of the recipient list id, and cannot be used
     * as a questionnaire id to get or update a questionnaire as of today. This is a hack to avoid
     * caching issues in relay. Perhaps we'll make this more explicit by defining a new type,
     * RecipientListQuestionnaire.
     */
    readonly aggregatedCustomizedQuestionnaire?: Maybe<RecipientListAggregatedCustomizedQuestionaire>;
    /** Fetches the correct version of the aggregated questionnaire that is used for this recipient list */
    readonly aggregatedQuestionnaire: AggregatedQuestionnaire;
    /** You can customize which questions / indicators that the respondents should see */
    readonly customizedQuestionnaire: CustomizedQuestionnaire;
    readonly id: Scalars['ID']['output'];
    readonly locale?: Maybe<Scalars['LanguageTag']['output']>;
    readonly originalId: Scalars['ID']['output'];
    readonly originalQuestionnaireId: Scalars['String']['output'];
    readonly questionResponses: ReadonlyArray<QuestionResponse>;
    readonly questionnaire: QuestionnaireInterface;
    readonly questionnaireId: Scalars['ID']['output'];
    readonly questionnaireVersion?: Maybe<Scalars['Int']['output']>;
    /**
     * Get the number of recipients in this list. In reality, only a person who has a
     * way of contact, could be a recipient in the list (email, sms) but the
     * technical implementation currently includes QR_CODE, SMS_CODE and LINK
     * respondents as recipients in this list as well. If you are only interested in
     * the number of recipient of a specific type, you can specify this with `recipientTypes`
     */
    readonly recipientCount: Scalars['Int']['output'];
    readonly recipients: ReadonlyArray<Recipient>;
    readonly reminders?: Maybe<ReadonlyArray<RecipientReminder>>;
    readonly responseCount: Scalars['Int']['output'];
    /**
     * A code to be used for sending an SMS to a binosight phone number. A service will respond with a link to
     * answer a survey using this list when you send an SMS with this code to +46 790 644 244.
     *
     * This code is automatically generated the first time the status changes to SURVEY_OPEN
     */
    readonly smsCode?: Maybe<Scalars['String']['output']>;
    readonly status: RecipientListStatus;
    /**
     * Returns a code to access the survey for this recipient list. You may configure
     * the invitation to pre-register meta question responses. Each combination of
     * responses will generate a unique code that can be used to create a respondent
     */
    readonly surveyCode: RecipientListSurveyCode;
    readonly surveyCodes: ReadonlyArray<RecipientListSurveyCode>;
    readonly textReplacements: ReadonlyArray<TextReplacement>;
};

export type RecipientListAggregatedCustomizedQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type RecipientListAggregatedQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type RecipientListQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type RecipientListRecipientCountArgs = {
    recipientTypes?: InputMaybe<ReadonlyArray<RecipientType>>;
};

export type RecipientListSurveyCodeArgs = {
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
    preRegisterMetaQuestionResponses?: InputMaybe<
        ReadonlyArray<QuestionResponseInput>
    >;
};

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaire =
    QuestionnaireInterface & {
        readonly __typename?: 'RecipientListAggregatedCustomizedQuestionaire';
        readonly availableLocales: ReadonlyArray<
            Scalars['LanguageTag']['output']
        >;
        /** @deprecated Use the tools available in your programming language (such as Intl) */
        readonly availableLocalesInfo: ReadonlyArray<LocaleInfo>;
        /** This id is based on the recipient list id and cannot be used to compare with other questionnaire objects */
        readonly id: Scalars['ID']['output'];
        readonly indicators: ReadonlyArray<Indicator>;
        readonly locale: Scalars['LanguageTag']['output'];
        /** @deprecated Use the tools available in your programming language (such as Intl) */
        readonly localeInfo: LocaleInfo;
        readonly name?: Maybe<Scalars['String']['output']>;
        /** @deprecated Use rawId */
        readonly originalId: Scalars['String']['output'];
        readonly questions: ReadonlyArray<Question>;
        /** The raw id is the original questionnaire id */
        readonly rawId: Scalars['String']['output'];
        readonly referenceData?: Maybe<QuestionnaireReferenceData>;
        readonly responseScales: ReadonlyArray<ResponseScale>;
        readonly sections: ReadonlyArray<Section>;
        readonly standardTexts: ReadonlyArray<StandardText>;
        readonly textReplacements: ReadonlyArray<TextReplacement>;
        readonly version: Scalars['Int']['output'];
        readonly visibilityConditions: ReadonlyArray<VisibilityCondition>;
    };

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaireAvailableLocalesInfoArgs =
    {
        inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
    };

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaireLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaireQuestionsArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
};

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaireReferenceDataArgs = {
    name: Scalars['String']['input'];
};

/** A questionnaire that is customized for a specific recipient list */
export type RecipientListAggregatedCustomizedQuestionaireStandardTextsArgs = {
    prefix?: InputMaybe<Scalars['String']['input']>;
    types?: InputMaybe<ReadonlyArray<StandardTextType>>;
};

export enum RecipientListStatus {
    Deleted = 'DELETED',
    SurveyClosed = 'SURVEY_CLOSED',
    SurveyNotOpened = 'SURVEY_NOT_OPENED',
    SurveyOpen = 'SURVEY_OPEN',
}

export type RecipientListSurveyCode = {
    readonly __typename?: 'RecipientListSurveyCode';
    readonly code: Scalars['String']['output'];
    /** New repondents using this code will use the specified locale by default instead of the recipient list default. */
    readonly locale?: Maybe<Scalars['LanguageTag']['output']>;
    /** New respondent created using this survey code will have these pre-registered meta question responses */
    readonly metaQuestionResponses: ReadonlyArray<QuestionResponse>;
    /** A reference to the recipient list that this survey code belongs to */
    readonly recipientList: RecipientList;
    /**
     * Requesting an SMS-code for this survey code will try to create a new SMS code if none was
     * previously created
     */
    readonly smsCode: Scalars['String']['output'];
};

/** A record sent reminders */
export type RecipientReminder = {
    readonly __typename?: 'RecipientReminder';
    /** Is this the last reminder? */
    readonly isLastReminder: Scalars['Boolean']['output'];
    /** Which reminder number is it */
    readonly reminderNumber: Scalars['Int']['output'];
    /** Was is sent? Even if it is sent, it can be sent again, but only to recipients who has not received this reminder */
    readonly sent: Scalars['Boolean']['output'];
    /** When was this reminder first sent. */
    readonly sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum RecipientStatus {
    Added = 'ADDED',
    RemovedSelf = 'REMOVED_SELF',
    Responded = 'RESPONDED',
}

export enum RecipientType {
    Email = 'EMAIL',
    Link = 'LINK',
    QrCode = 'QR_CODE',
    Sms = 'SMS',
    SmsCode = 'SMS_CODE',
}

export type RegisterProjectInvoiceInformationInput = {
    readonly invoiceInformation: InvoiceInformationInput;
    readonly projectId: Scalars['ID']['input'];
};

export type RegisterProjectInvoiceInformationPayload = {
    readonly __typename?: 'RegisterProjectInvoiceInformationPayload';
    readonly project?: Maybe<Project>;
};

export type RegisterProjectSubscriptionDiscountCodeInput = {
    readonly discountCode: Scalars['String']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type RegisterProjectSubscriptionDiscountCodePayload = {
    readonly __typename?: 'RegisterProjectSubscriptionDiscountCodePayload';
    readonly isValidDiscountCode?: Maybe<Scalars['Boolean']['output']>;
    readonly project?: Maybe<Project>;
};

export type RegisterQuestionResponseInput = {
    readonly comment?: InputMaybe<Scalars['String']['input']>;
    readonly improve?: InputMaybe<Scalars['Boolean']['input']>;
    readonly noOpinion?: InputMaybe<Scalars['Boolean']['input']>;
    readonly questionId: Scalars['ID']['input'];
    readonly respondentId: Scalars['ID']['input'];
    readonly selectedResponseOptions?: InputMaybe<
        ReadonlyArray<ResponseOptionResponseInput>
    >;
};

export type RegisterQuestionResponsePayload = {
    readonly __typename?: 'RegisterQuestionResponsePayload';
    readonly questionResponse?: Maybe<QuestionResponse>;
};

export type RegisterRecipientListQuestionResponseInput = {
    readonly questionResponses: ReadonlyArray<QuestionResponseInput>;
    readonly recipientListId: Scalars['ID']['input'];
};

export type RegisterRecipientListQuestionResponsePayload = {
    readonly __typename?: 'RegisterRecipientListQuestionResponsePayload';
    /** @deprecated Use questionResponses instead to get a list of updated responses on the recipient list */
    readonly questionResponse?: Maybe<QuestionResponse>;
    readonly questionResponses?: Maybe<ReadonlyArray<QuestionResponse>>;
};

export type RegisterRespondentConsentInput = {
    readonly respondentId: Scalars['ID']['input'];
};

export type RegisterRespondentConsentPayload = {
    readonly __typename?: 'RegisterRespondentConsentPayload';
    readonly respondentGaveConsent: Scalars['Boolean']['output'];
};

export type RegisterTeamInvoiceInformationInput = {
    readonly invoiceInformation: InvoiceInformationInput;
    readonly teamId: Scalars['ID']['input'];
};

export type RegisterTeamInvoiceInformationPayload = {
    readonly __typename?: 'RegisterTeamInvoiceInformationPayload';
    readonly team?: Maybe<Team>;
};

export type RemindRecipientsInput = {
    readonly isLastReminder?: InputMaybe<Scalars['Boolean']['input']>;
    readonly recipientListId: Scalars['ID']['input'];
    readonly reminderNumber: Scalars['Int']['input'];
};

export type RemindRecipientsPayload = {
    readonly __typename?: 'RemindRecipientsPayload';
    readonly isLastReminder?: Maybe<Scalars['Boolean']['output']>;
    readonly recipientList: RecipientList;
    readonly recipientListId: Scalars['ID']['output'];
    readonly reminderNumber: Scalars['Int']['output'];
};

export type RemoveRecipientsFromListInput = {
    readonly emailAddresses?: InputMaybe<
        ReadonlyArray<Scalars['String']['input']>
    >;
    readonly phoneNumbers?: InputMaybe<
        ReadonlyArray<Scalars['String']['input']>
    >;
    readonly recipientListId: Scalars['ID']['input'];
    readonly respondentIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type RemoveRecipientsFromListPayload = {
    readonly __typename?: 'RemoveRecipientsFromListPayload';
    readonly success?: Maybe<Scalars['Boolean']['output']>;
    /** Cached results has been updated */
    readonly updatedCaches?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSelfAsRespondentInput = {
    readonly respondentId: Scalars['ID']['input'];
};

export type RemoveSelfAsRespondentPayload = {
    readonly __typename?: 'RemoveSelfAsRespondentPayload';
    readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveSurveyInput = {
    readonly surveyId: Scalars['ID']['input'];
};

export type RemoveSurveyPayload = {
    readonly __typename?: 'RemoveSurveyPayload';
    readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type RenamePortfolioInput = {
    readonly name: Scalars['String']['input'];
    readonly portfolioId: Scalars['ID']['input'];
};

export type RenamePortfolioPayload = {
    readonly __typename?: 'RenamePortfolioPayload';
    readonly portfolio?: Maybe<SubPortfolio>;
};

export type RenameProjectCategoryInput = {
    readonly name: Scalars['String']['input'];
    readonly projectCategoryId: Scalars['ID']['input'];
};

export type RenameProjectCategoryPayload = {
    readonly __typename?: 'RenameProjectCategoryPayload';
    /** The updated project category */
    readonly projectCategory?: Maybe<ProjectCategory>;
};

export type RenameProjectInput = {
    /** New official name of the project */
    readonly name: Scalars['String']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type RenameProjectPayload = {
    readonly __typename?: 'RenameProjectPayload';
    readonly project?: Maybe<ProjectInterface>;
};

export type RenameTeamInput = {
    readonly teamId: Scalars['ID']['input'];
    readonly teamName: Scalars['String']['input'];
};

export type RenameTeamPayload = {
    readonly __typename?: 'RenameTeamPayload';
    readonly team?: Maybe<Team>;
};

export type RenewDashboardSubscriptionInput = {
    readonly subscription: DashboardSubscriptionInput;
    readonly teamId: Scalars['ID']['input'];
};

export type RenewDashboardSubscriptionPayload = {
    readonly __typename?: 'RenewDashboardSubscriptionPayload';
    readonly team?: Maybe<Team>;
};

export type ReopenSurveyInput = {
    readonly surveyId: Scalars['ID']['input'];
    /** The survey will be open for response until the end of this day */
    readonly until: Scalars['Date']['input'];
};

export type ReopenSurveyPayload = {
    readonly __typename?: 'ReopenSurveyPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type RequestProjectSubscriptionCancellationInput = {
    /**
     * Cancel the subscription immediately. This is only allowed to do by certain users and special conditions apply, so
     * the request might be ignored, and the subscription will be cancelled according to project subscription terms and
     * conditions.
     */
    readonly instantly?: InputMaybe<Scalars['Boolean']['input']>;
    /** Used if you specify "Other" reason  */
    readonly otherReason?: InputMaybe<Scalars['String']['input']>;
    readonly projectId: Scalars['ID']['input'];
    readonly reason: ProjectSubscriptionCancellationReason;
};

export type RequestProjectSubscriptionCancellationPayload = {
    readonly __typename?: 'RequestProjectSubscriptionCancellationPayload';
    readonly project?: Maybe<Project>;
};

/** Customize which questions that should be used for a survey */
export type RequestStableQuestionnaireVersionForRecipientListInput = {
    readonly recipientListId: Scalars['ID']['input'];
    /**
     * Optionally use a specific version, otherwise the most recent stable
     * version will be used.
     */
    readonly version?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestStableQuestionnaireVersionForRecipientListPayload = {
    readonly __typename?: 'RequestStableQuestionnaireVersionForRecipientListPayload';
    /**
     * The recipient list will have an updated version field, and
     * the questionnaire may also be updated to a new version
     */
    readonly recipientList?: Maybe<RecipientList>;
};

export type RequestUploadOfDashboardSubscriptionContractInput = {
    readonly fileName: Scalars['String']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type RequestUploadOfDashboardSubscriptionContractPayload = {
    readonly __typename?: 'RequestUploadOfDashboardSubscriptionContractPayload';
    readonly uploadUrl: Scalars['String']['output'];
};

export type ResourceGrant = {
    readonly __typename?: 'ResourceGrant';
    /**
     * A list of actions that this role can perform. May include wildcards (*). The format of an action is
     * "Module.MessageName" where MessageName is either a command or a query
     *
     * NOTE: The action names are internal and may change at any time.
     *
     * Examples:
     *     PQi.ProjectCategory.Create
     *     PQi.Project.Create
     *     PQi.AddProjectSurvey
     *     PQi.ListProjects
     *     PQi.GetProject
     *     Questionnaire.CreateChildQuestionnaire
     *     Questionnaire.AddQuestion
     *     Questionnaire.AddRecipientsToList
     *     etc..
     */
    readonly actions: ReadonlyArray<Scalars['String']['output']>;
    /**
     * The graphql node ID of the resource that the user has a grant for.
     *
     * Some grants does not have a node
     */
    readonly nodeID?: Maybe<Scalars['ID']['output']>;
    /**
     * The graphql node type of the resource that the user has a grant for.
     *
     * Some grants does not have a node
     */
    readonly nodeType?: Maybe<Scalars['String']['output']>;
    /**
     * Internal resource name for the resource that the user has a grant for. The format for the name is
     * "Module.ResourceType.ResourceID"
     *
     * For example a project with ID 12341234-1234-1234-123412341234 would be "PQi.Project.12341234-1234-1234-123412341234"
     */
    readonly resourceName: Scalars['String']['output'];
    /** Internal role name of the role that the user has for this resource */
    readonly roleName: Scalars['String']['output'];
};

export type Respondent = {
    readonly __typename?: 'Respondent';
    readonly id: Scalars['ID']['output'];
    readonly locale?: Maybe<Scalars['LanguageTag']['output']>;
    readonly originalQuestionnaireId: Scalars['ID']['output'];
    readonly questionResponses: ReadonlyArray<QuestionResponse>;
    /** Will return an aggregated questionnaire without questions that is not available for the questionnaire locale */
    readonly questionnaire: RespondentQuestionnaire;
    readonly questionnaireId: Scalars['ID']['output'];
    readonly recipientList: RecipientList;
    readonly recipientListId: Scalars['ID']['output'];
    readonly removedSelf: Scalars['Boolean']['output'];
    readonly respondentGaveConsent: Scalars['Boolean']['output'];
};

export type RespondentQuestionResponsesArgs = {
    questionIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type RespondentQuestionnaireArgs = {
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaire = QuestionnaireInterface & {
    readonly __typename?: 'RespondentQuestionnaire';
    readonly availableLocales: ReadonlyArray<Scalars['LanguageTag']['output']>;
    /** @deprecated Use the tools available in your programming language (such as Intl) */
    readonly availableLocalesInfo: ReadonlyArray<LocaleInfo>;
    /** This id is based on the respondend id and cannot be used to compare with other questionnaire objects */
    readonly id: Scalars['ID']['output'];
    readonly indicators: ReadonlyArray<Indicator>;
    readonly locale: Scalars['LanguageTag']['output'];
    /** @deprecated Use the tools available in your programming language (such as Intl) */
    readonly localeInfo: LocaleInfo;
    readonly name?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use rawId */
    readonly originalId: Scalars['String']['output'];
    readonly questions: ReadonlyArray<Question>;
    readonly rawId: Scalars['String']['output'];
    readonly referenceData?: Maybe<QuestionnaireReferenceData>;
    readonly responseScales: ReadonlyArray<ResponseScale>;
    readonly sections: ReadonlyArray<Section>;
    readonly standardTexts: ReadonlyArray<StandardText>;
    readonly textReplacements: ReadonlyArray<TextReplacement>;
    readonly version: Scalars['Int']['output'];
    readonly visibilityConditions: ReadonlyArray<VisibilityCondition>;
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaireAvailableLocalesInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaireLocaleInfoArgs = {
    inLocaleId?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaireQuestionsArgs = {
    questionFilter?: InputMaybe<QuestionFilterInput>;
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaireReferenceDataArgs = {
    name: Scalars['String']['input'];
};

/** A questionnaire that is customized for a specific respondent */
export type RespondentQuestionnaireStandardTextsArgs = {
    prefix?: InputMaybe<Scalars['String']['input']>;
    types?: InputMaybe<ReadonlyArray<StandardTextType>>;
};

export type ResponseOption = {
    readonly __typename?: 'ResponseOption';
    /** This value can be displayed instead of the value */
    readonly displayValue?: Maybe<Scalars['String']['output']>;
    /** An extra explanatory text for the response options. Used for nominal scales */
    readonly explanatoryText?: Maybe<Scalars['String']['output']>;
    /**
     * Is this response option hidden and no longer in use.
     * NULL and FALSE means the same thing. Only TRUE means hidden
     */
    readonly hidden?: Maybe<Scalars['Boolean']['output']>;
    /** Label/name for the response option */
    readonly label?: Maybe<Scalars['String']['output']>;
    /** Non-relay version of the ID */
    readonly originalVisibilityConditionId?: Maybe<Scalars['String']['output']>;
    /** A list of tags that can be used to describe the response option */
    readonly tags: ReadonlyArray<Scalars['String']['output']>;
    /**
     * Value of the response option. This cannot be changed and can be used and is unique for the response scale.
     * For ORDINAL, INTERVAL and RATIO scales, this value can be used to calculate an average, but for NOMINAL scales
     * the value has real usage other than to identify the response option.
     */
    readonly value: Scalars['Int']['output'];
    /**
     * It is possible to assign a visibility condition to a response option for a nominal response scale
     * When assigned, this condition should be evaluated, and the response option may be hidden based on the conditions
     * in the visibility condition.
     */
    readonly visibilityConditionId?: Maybe<Scalars['ID']['output']>;
};

export type ResponseOptionResponse = {
    readonly __typename?: 'ResponseOptionResponse';
    readonly comment?: Maybe<Scalars['String']['output']>;
    readonly firstTime?: Maybe<Scalars['Boolean']['output']>;
    readonly value: Scalars['Int']['output'];
};

export type ResponseOptionResponseInput = {
    readonly comment?: InputMaybe<Scalars['String']['input']>;
    readonly value: Scalars['Int']['input'];
};

export type ResponseOptionResult = {
    readonly __typename?: 'ResponseOptionResult';
    readonly count?: Maybe<Scalars['Int']['output']>;
    readonly percent?: Maybe<Scalars['Float']['output']>;
    readonly value?: Maybe<Scalars['Int']['output']>;
};

export type ResponseOptionTranslation = {
    readonly __typename?: 'ResponseOptionTranslation';
    readonly displayValue?: Maybe<Scalars['String']['output']>;
    readonly explanatoryText?: Maybe<Scalars['String']['output']>;
    readonly label?: Maybe<Scalars['String']['output']>;
    readonly locale: Scalars['LanguageTag']['output'];
    readonly value: Scalars['Int']['output'];
};

export type ResponseScale = {
    readonly __typename?: 'ResponseScale';
    readonly commentPlaceholder?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderHighValue?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderLowValue?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderNeutralValue?: Maybe<
        Scalars['String']['output']
    >;
    readonly highValueThreshold?: Maybe<Scalars['Int']['output']>;
    readonly id: Scalars['ID']['output'];
    readonly inheritToChildQuestionnaires: Scalars['Boolean']['output'];
    readonly lowValueThreshold?: Maybe<Scalars['Int']['output']>;
    readonly originalId: Scalars['String']['output'];
    readonly responseOptions: ReadonlyArray<ResponseOption>;
    readonly reusable: Scalars['Boolean']['output'];
    readonly statement?: Maybe<Scalars['String']['output']>;
    readonly translation?: Maybe<ResponseScaleTranslation>;
    readonly translations: ReadonlyArray<ResponseScaleTranslation>;
    readonly type: ResponseScaleType;
};

export type ResponseScaleTranslationArgs = {
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type ResponseScaleResult = {
    readonly __typename?: 'ResponseScaleResult';
    readonly average?: Maybe<Scalars['Float']['output']>;
    readonly signalSpread?: Maybe<ReadonlyArray<SignalResult>>;
    readonly spread?: Maybe<ReadonlyArray<ResponseOptionResult>>;
};

export type ResponseScaleTranslation = {
    readonly __typename?: 'ResponseScaleTranslation';
    readonly commentPlaceholder?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderHighValue?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderLowValue?: Maybe<Scalars['String']['output']>;
    readonly commentPlaceholderNeutralValue?: Maybe<
        Scalars['String']['output']
    >;
    readonly id: Scalars['ID']['output'];
    readonly locale: Scalars['LanguageTag']['output'];
    readonly responseOptionTranslations: ReadonlyArray<ResponseOptionTranslation>;
    readonly responseScaleId: Scalars['ID']['output'];
    readonly statement?: Maybe<Scalars['String']['output']>;
};

export enum ResponseScaleType {
    Interval = 'INTERVAL',
    Nominal = 'NOMINAL',
    Ordinal = 'ORDINAL',
    Ratio = 'RATIO',
}

export type Result = {
    readonly resultType: ResultType;
};

/**
 * To filter results from a specific questionnaire:
 * {
 *     metaKey: 'Questionnaire'
 *     metaValues: [ 'a-questionnaire-id', ...]
 * }
 *
 * To filter results from a specific recipient list:
 * {
 *     metaKey: 'RecipientList'
 *     metaValues: [ 'a-recipient-list-id', ...]
 * }
 *
 * To filter results from a meta question response:
 * {
 *     metaKey: 'Question-a-question-id',
 *     metaValues: [ $responseOptionValue, ...]
 * }
 *
 * or omit the Question- prefix, and it will be automatically filtered as a question
 * {
 *     metaKey: 'a-question-id',
 *     metaValues: [ $responseOptionValue, ...]
 * }
 *
 * If you want to match ANY result, you can for each filter set matchAny to true, this will essentially
 * create two groups of filters, one group that matches all, and another group that matches any. If you
 * have both groups, both groups must must match or there will be no results
 */
export type ResultFilter = {
    /**
     * You can specify that this filter should be placed in the "match any" group.
     * This is a simplified way of creating the filters. Later on we will support
     * more advanced cased using and/or/not
     */
    readonly matchAny?: InputMaybe<Scalars['Boolean']['input']>;
    readonly metaKey: Scalars['String']['input'];
    readonly metaValues: ReadonlyArray<Scalars['String']['input']>;
};

export type ResultFilterMatch = {
    readonly metaKey: Scalars['String']['input'];
    readonly metaValues: ReadonlyArray<Scalars['String']['input']>;
};

export enum ResultType {
    Indicator = 'INDICATOR',
    Question = 'QUESTION',
}

export type ResumeProjectInput = {
    readonly projectId: Scalars['ID']['input'];
};

export type ResumeProjectPayload = {
    readonly __typename?: 'ResumeProjectPayload';
    readonly project?: Maybe<Project>;
};

export type RevokeTeamMemberAccessInput = {
    /** Roles to remove */
    readonly roles: ReadonlyArray<TeamMemberRoleInput>;
    readonly teamId: Scalars['ID']['input'];
    /** The user identity */
    readonly userId: Scalars['ID']['input'];
};

export type RevokeTeamMemberAccessPayload = {
    readonly __typename?: 'RevokeTeamMemberAccessPayload';
    /** For each role that has is revoked from a project, we include these projects here */
    readonly projects?: Maybe<ReadonlyArray<Project>>;
    readonly team?: Maybe<Team>;
};

export type ScoreBestPractice = BestPractice & {
    readonly __typename?: 'ScoreBestPractice';
    readonly P10: Scalars['Float']['output'];
    readonly P25: Scalars['Float']['output'];
    readonly P75: Scalars['Float']['output'];
    readonly P90: Scalars['Float']['output'];
};

export type Section = {
    readonly __typename?: 'Section';
    /** The description is used when showing additional info about the section, such as in tooltip's or a menu */
    readonly description?: Maybe<Scalars['String']['output']>;
    readonly id: Scalars['ID']['output'];
    /** Optionally add some instructions to display next to the title */
    readonly instructions?: Maybe<Scalars['String']['output']>;
    /** A section may optionally have a key that can be used as an alternate identifier */
    readonly key?: Maybe<Scalars['String']['output']>;
    /** The name is used when showing additional info about the section, such as in tooltip's or a menu */
    readonly name?: Maybe<Scalars['String']['output']>;
    readonly originalId: Scalars['String']['output'];
    readonly originalQuestionIds: ReadonlyArray<Scalars['String']['output']>;
    /** The questions in the section in the order they should appear */
    readonly questionIds: ReadonlyArray<Scalars['ID']['output']>;
    /** The title should be used as an intro to the section before showing the questions in the section */
    readonly title?: Maybe<Scalars['String']['output']>;
};

export type SectionTranslation = {
    readonly __typename?: 'SectionTranslation';
    readonly description?: Maybe<Scalars['String']['output']>;
    readonly id: Scalars['ID']['output'];
    readonly instructions?: Maybe<Scalars['String']['output']>;
    readonly locale: Scalars['LanguageTag']['output'];
    readonly name?: Maybe<Scalars['String']['output']>;
    readonly sectionId: Scalars['ID']['output'];
    readonly title?: Maybe<Scalars['String']['output']>;
};

export type SelectProjectSurveySenderInput = {
    readonly customSenderLineOne?: InputMaybe<Scalars['String']['input']>;
    readonly customSenderLineTwo?: InputMaybe<Scalars['String']['input']>;
    readonly sender: ProjectSurveySender;
    readonly surveyId: Scalars['ID']['input'];
};

export type SelectProjectSurveySenderPayload = {
    readonly __typename?: 'SelectProjectSurveySenderPayload';
    readonly survey?: Maybe<ProjectSurvey>;
};

export type SetProjectBudgetInput = {
    /**
     * If you are a construction client, enter total budgeted project cost excluding land cost.
     * If you are a contractor, enter total contract amount including subcontractors and sub-suppliers.
     */
    readonly budget: MoneyInput;
    /**
     * The project budget is used to determine the cost of the project subscription. In order to start
     * a subscription, the budget correctness needs to be certified
     */
    readonly certifyBudgetCorrectness?: InputMaybe<Scalars['Boolean']['input']>;
    readonly projectId: Scalars['ID']['input'];
};

export type SetProjectBudgetPayload = {
    readonly __typename?: 'SetProjectBudgetPayload';
    readonly project?: Maybe<Project>;
};

export type SetProjectLocationInput = {
    readonly address: Scalars['String']['input'];
    readonly countryCode: Scalars['String']['input'];
    readonly latitude: Scalars['Float']['input'];
    readonly longitude: Scalars['Float']['input'];
    readonly projectId: Scalars['ID']['input'];
};

export type SetProjectLocationPayload = {
    readonly __typename?: 'SetProjectLocationPayload';
    readonly project?: Maybe<Project>;
};

export type SetReceivedProjectBudgetInput = {
    readonly budget: MoneyInput;
    readonly projectId: Scalars['ID']['input'];
};

export type SetReceivedProjectBudgetPayload = {
    readonly __typename?: 'SetReceivedProjectBudgetPayload';
    readonly project?: Maybe<ReceivedProject>;
};

export type ShareProjectWithTeamInput = {
    readonly futureSurveys: Scalars['Boolean']['input'];
    readonly projectId: Scalars['ID']['input'];
    readonly shareProjectQuestions: Scalars['Boolean']['input'];
    readonly shareTeamQuestions: Scalars['Boolean']['input'];
    readonly surveyNumbers: ReadonlyArray<Scalars['Int']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type ShareProjectWithTeamResponse = {
    readonly __typename?: 'ShareProjectWithTeamResponse';
    readonly project: Project;
};

export type SharedProjectDetails = {
    readonly __typename?: 'SharedProjectDetails';
    readonly id: Scalars['ID']['output'];
    readonly name: Scalars['String']['output'];
    readonly projectId: Scalars['ID']['output'];
    readonly responsiblePerson?: Maybe<User>;
    /** @deprecated Use teamName. No need to expose team id */
    readonly team: TeamBasicInfo;
    readonly teamName: Scalars['String']['output'];
};

export type SignalResult = {
    readonly __typename?: 'SignalResult';
    readonly count: Scalars['Int']['output'];
    readonly percent: Scalars['Float']['output'];
    readonly signalValue: Scalars['Int']['output'];
};

export type SortProjectCategoriesInput = {
    readonly projectCategoryIds: ReadonlyArray<Scalars['ID']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type SortProjectCategoriesResponse = {
    readonly __typename?: 'SortProjectCategoriesResponse';
    readonly team?: Maybe<Team>;
};

export type SortProjectSurveyTemplatesInput = {
    readonly ids: ReadonlyArray<Scalars['ID']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type SortQuestionsInput = {
    readonly questionIds: ReadonlyArray<Scalars['ID']['input']>;
    readonly questionnaireId: Scalars['ID']['input'];
};

export type SortQuestionsPayload = {
    readonly __typename?: 'SortQuestionsPayload';
    readonly questionnaire?: Maybe<Questionnaire>;
};

export type SortQuestionsPayloadQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type StandardText = {
    readonly __typename?: 'StandardText';
    readonly format: StandardTextFormat;
    readonly messages: ReadonlyArray<StandardTextMessage>;
    readonly subType?: Maybe<Scalars['String']['output']>;
    readonly text: Scalars['String']['output'];
    readonly translations: ReadonlyArray<StandardTextTranslation>;
    readonly type: StandardTextType;
};

export enum StandardTextFormat {
    /**
     * Standard text that uses the JSX format are mainly used to be rendered on the backend as notifications. When
     * using JSX, you may also use the StandardText.messages property for localized content.
     *
     * The following components are available
     *
     * * Button
     *     - href
     * * Link
     *     - href
     *     - uppercase (default: true)
     * * Message
     *
     *     Format an ICU message. Allows one jsx components: Bold
     *
     *     - id Which message to render.
     *     - locale Override the default locale
     *
     * * Paragraph
     *     - small Makes the text smaller
     *     - gray Makes the text gray
     * * Title
     * * Subtitle
     * * Text
     * * Fragment
     * * EmailBody
     * * br, hr, div, span, a
     */
    Jsx = 'Jsx',
    MarkDown = 'MarkDown',
    PlainText = 'PlainText',
}

export type StandardTextMessage = {
    readonly __typename?: 'StandardTextMessage';
    readonly key: Scalars['String']['output'];
    readonly value: Scalars['String']['output'];
};

export type StandardTextTranslation = {
    readonly __typename?: 'StandardTextTranslation';
    readonly format: StandardTextFormat;
    readonly locale: Scalars['LanguageTag']['output'];
    readonly messages: ReadonlyArray<StandardTextMessage>;
    readonly subType?: Maybe<Scalars['String']['output']>;
    readonly text: Scalars['String']['output'];
    readonly type: StandardTextType;
};

export enum StandardTextType {
    AnswerSurveyCloseHelpButton = 'AnswerSurveyCloseHelpButton',
    AnswerSurveyClosePauseButton = 'AnswerSurveyClosePauseButton',
    AnswerSurveyConfirmRemoveMeButton = 'AnswerSurveyConfirmRemoveMeButton',
    AnswerSurveyConfirmRemoveMeText = 'AnswerSurveyConfirmRemoveMeText',
    AnswerSurveyDefaultCommentPlaceholder = 'AnswerSurveyDefaultCommentPlaceholder',
    AnswerSurveyDone = 'AnswerSurveyDone',
    AnswerSurveyGoToCurrentQuestion = 'AnswerSurveyGoToCurrentQuestion',
    AnswerSurveyHelpLabel = 'AnswerSurveyHelpLabel',
    AnswerSurveyHelpText = 'AnswerSurveyHelpText',
    AnswerSurveyImprovementQuestion = 'AnswerSurveyImprovementQuestion',
    AnswerSurveyImprovementQuestionNo = 'AnswerSurveyImprovementQuestionNo',
    AnswerSurveyImprovementQuestionYes = 'AnswerSurveyImprovementQuestionYes',
    AnswerSurveyInstructions = 'AnswerSurveyInstructions',
    AnswerSurveyNextQuestionButton = 'AnswerSurveyNextQuestionButton',
    AnswerSurveyNoOpinion = 'AnswerSurveyNoOpinion',
    AnswerSurveyNominalResponseScaleHelpText = 'AnswerSurveyNominalResponseScaleHelpText',
    AnswerSurveyPauseLabel = 'AnswerSurveyPauseLabel',
    AnswerSurveyPauseText = 'AnswerSurveyPauseText',
    AnswerSurveyRemoveMeLink = 'AnswerSurveyRemoveMeLink',
    AnswerSurveyRemovedSelfText = 'AnswerSurveyRemovedSelfText',
    AnswerSurveyRespondentConsentStatement = 'AnswerSurveyRespondentConsentStatement',
    AnswerSurveyScrollUpToChange = 'AnswerSurveyScrollUpToChange',
    AnswerSurveySectionContinueButton = 'AnswerSurveySectionContinueButton',
    AnswerSurveySectionHeader = 'AnswerSurveySectionHeader',
    AnswerSurveySectionNumber = 'AnswerSurveySectionNumber',
    AnswerSurveySkipQuestionButton = 'AnswerSurveySkipQuestionButton',
    AnswerSurveyStartButton = 'AnswerSurveyStartButton',
    AnswerSurveyUndoRemoveMeButton = 'AnswerSurveyUndoRemoveMeButton',
    RespondentInvitationEmail = 'RespondentInvitationEmail',
    RespondentInvitationSms = 'RespondentInvitationSms',
    RespondentLastReminderEmail = 'RespondentLastReminderEmail',
    RespondentLastReminderSms = 'RespondentLastReminderSms',
    RespondentReminderEmail = 'RespondentReminderEmail',
    RespondentReminderSms = 'RespondentReminderSms',
    RespondentStartedLastReminderEmail = 'RespondentStartedLastReminderEmail',
    RespondentStartedLastReminderSms = 'RespondentStartedLastReminderSms',
    RespondentStartedReminderEmail = 'RespondentStartedReminderEmail',
    RespondentStartedReminderSms = 'RespondentStartedReminderSms',
}

export type StartDashboardSubscriptionInput = {
    readonly subscription: DashboardSubscriptionInput;
    readonly teamId: Scalars['ID']['input'];
};

export type StartDashboardSubscriptionPayload = {
    readonly __typename?: 'StartDashboardSubscriptionPayload';
    readonly team?: Maybe<Team>;
};

/** A project portfolio */
export type SubPortfolio = Portfolio & {
    readonly __typename?: 'SubPortfolio';
    /**
     * All ancestors (parent portfolios) starting with the closes ancestor first.
     * The ancestors also includes the main portfolio.
     */
    readonly ancestors: ReadonlyArray<Portfolio>;
    readonly id: Scalars['ID']['output'];
    /** The name of this sub portfolio */
    readonly name: Scalars['String']['output'];
    /** The parent portfolio is either another SubPortfolio or the MainPortfolio */
    readonly parent: Portfolio;
    /** @deprecated Use parent { id } */
    readonly parentId: Scalars['ID']['output'];
    /**
     * This is used to make a URL to the sub portfolio. If the portfolio name is "My portfolio" the path
     * will be "my-portfolio"
     */
    readonly path: Scalars['String']['output'];
    readonly project?: Maybe<ProjectInterface>;
    readonly projectCount: Scalars['Int']['output'];
    readonly projectSurveys: ReadonlyArray<ProjectSurvey>;
    readonly projects: ReadonlyArray<ProjectInterface>;
    readonly subPortfolios: ReadonlyArray<SubPortfolio>;
    readonly team: Team;
    /** @deprecated Use team { id } */
    readonly teamId: Scalars['ID']['output'];
    readonly totalProjectCount: Scalars['Int']['output'];
};

/** A project portfolio */
export type SubPortfolioProjectArgs = {
    path: Scalars['String']['input'];
};

/** A project portfolio */
export type SubPortfolioProjectSurveysArgs = {
    filter?: InputMaybe<ProjectSurveyFilterInput>;
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A project portfolio */
export type SubPortfolioProjectsArgs = {
    fromThisPortfolioOnly?: InputMaybe<Scalars['Boolean']['input']>;
    onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A project portfolio */
export type SubPortfolioSubPortfoliosArgs = {
    directChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Team = Node & {
    readonly __typename?: 'Team';
    /** This team is searchable for projects who wants to share results */
    readonly allowReceiveSharedProjects: Scalars['Boolean']['output'];
    readonly bestPractice: ReadonlyArray<BestPractice>;
    readonly id: Scalars['ID']['output'];
    readonly improvementBankId?: Maybe<Scalars['ID']['output']>;
    readonly industryConnections: ReadonlyArray<Scalars['String']['output']>;
    readonly invoiceInformation: InvoiceInformation;
    readonly mainContactAtBinosight?: Maybe<TeamContactPerson>;
    readonly mainContactAtCustomer?: Maybe<TeamContactPerson>;
    /**
     * Get the main portfolio. Another way to get the main portfolio is to just use the portfolio field without
     * an argument or with an empty path: portfolio(path: "") {...} or portfolio {...}
     */
    readonly mainPortfolio: MainPortfolio;
    readonly masterQuestionnaire?: Maybe<Questionnaire>;
    /** This is the main questionnaire */
    readonly masterQuestionnaireId: Scalars['ID']['output'];
    readonly measuringModelId: Scalars['ID']['output'];
    readonly members: ReadonlyArray<TeamMember>;
    readonly name: Scalars['String']['output'];
    readonly organizationNumber?: Maybe<Scalars['String']['output']>;
    readonly originalId: Scalars['String']['output'];
    readonly path: Scalars['String']['output'];
    /**
     * Get a portfolio by path. If you dont give a value for path or use an empty string, the main portfolio will
     * be returned. Otherwise a sub portfolio will be returned.
     *
     * The path is not hierarchical, but rather the url-path version of the portfolio name. So if you have a hierarchy of
     * a > b > c and you want you fetch portfolio C, you just do portfolio(path: "c"), not "a/b/c".
     */
    readonly portfolio?: Maybe<Portfolio>;
    /** A flat list of all sub portfolios */
    readonly portfolios: ReadonlyArray<SubPortfolio>;
    /** Which pricing model applies to this customer. This field is internal, and is used in transition periods */
    readonly pricingModel: Scalars['String']['output'];
    /**
     * Get a project by it's path relative to this team
     * @deprecated Get projects via Portfolio
     */
    readonly projectByPath?: Maybe<ProjectInterface>;
    /** Get a list of project categories for this team */
    readonly projectCategories: ReadonlyArray<ProjectCategory>;
    readonly projectSubscriptionDiscountCodes: ReadonlyArray<ProjectSubscriptionDiscountCode>;
    readonly projectSubscriptionPriceList: ProjectSubscriptionPriceList;
    /** Get a list of survey templates defined for this team */
    readonly projectSurveyTemplates: ReadonlyArray<ProjectSurveyTemplate>;
    /**
     * List all project surveys for all projects in this team (can be a lot)
     * @deprecated Get project surveys via Portfolio
     */
    readonly projectSurveys: ReadonlyArray<ProjectSurvey>;
    /**
     * List all projects in this team
     * @deprecated Get projects via Portfolio
     */
    readonly projects: ReadonlyArray<ProjectInterface>;
    readonly questionnaire?: Maybe<QuestionnaireInterface>;
    /** A questionnaire is assigned to the organization team for customization purposes */
    readonly questionnaireId?: Maybe<Scalars['ID']['output']>;
    /** The version of the questionnaire that this team currently uses */
    readonly questionnaireVersion?: Maybe<Scalars['Int']['output']>;
    readonly subscription: DashboardSubscription;
    readonly yearlyProjectSurveysBudget: Scalars['Int']['output'];
};

export type TeamMasterQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type TeamPortfolioArgs = {
    path?: InputMaybe<Scalars['String']['input']>;
};

export type TeamProjectByPathArgs = {
    projectPath: Scalars['String']['input'];
};

export type TeamProjectSurveysArgs = {
    filter?: InputMaybe<ProjectSurveyFilterInput>;
};

export type TeamProjectsArgs = {
    onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamQuestionnaireArgs = {
    aggregated?: InputMaybe<Scalars['Boolean']['input']>;
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

/** Partial information about an organization/team.  */
export type TeamBasicInfo = {
    readonly __typename?: 'TeamBasicInfo';
    readonly id: Scalars['ID']['output'];
    readonly name: Scalars['String']['output'];
    readonly teamId: Scalars['ID']['output'];
};

export type TeamContactPerson = {
    readonly __typename?: 'TeamContactPerson';
    readonly emailAddress: Scalars['String']['output'];
    readonly fullName: Scalars['String']['output'];
    readonly phoneNumber: Scalars['String']['output'];
};

export type TeamContactPersonInput = {
    readonly emailAddress?: InputMaybe<Scalars['String']['input']>;
    readonly fullName: Scalars['String']['input'];
    readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TeamMember = {
    readonly __typename?: 'TeamMember';
    readonly enabledNotifications: ReadonlyArray<TeamMemberNotification>;
    readonly id: Scalars['ID']['output'];
    readonly roles: ReadonlyArray<TeamMemberRole>;
    readonly user: User;
};

export type TeamMemberNotification = {
    readonly __typename?: 'TeamMemberNotification';
    readonly portfolioId?: Maybe<Scalars['ID']['output']>;
    readonly type?: Maybe<PQiTeamMemberNotificationType>;
};

export type TeamMemberPortfolioRole = TeamMemberRole & {
    readonly __typename?: 'TeamMemberPortfolioRole';
    readonly name: TeamMemberRoleName;
    readonly portfolioId: Scalars['ID']['output'];
};

export type TeamMemberProjectRole = TeamMemberRole & {
    readonly __typename?: 'TeamMemberProjectRole';
    readonly name: TeamMemberRoleName;
    readonly projectId: Scalars['ID']['output'];
};

export type TeamMemberRole = {
    readonly name: TeamMemberRoleName;
};

export type TeamMemberRoleInput = {
    readonly name: TeamMemberRoleName;
    /** Optionally limit this role to this portfolio. Cannot be combined with any other binding. */
    readonly portfolioId?: InputMaybe<Scalars['ID']['input']>;
    /** Optionally bind this role to this project. Cannot be combined with any other binding. */
    readonly projectId?: InputMaybe<Scalars['ID']['input']>;
};

export enum TeamMemberRoleName {
    /** Can create projects */
    ProjectCreator = 'PROJECT_CREATOR',
    /** @deprecated Use SURVEY_ADMIN */
    ProjectManager = 'PROJECT_MANAGER',
    /** Can view results */
    ResultsViewer = 'RESULTS_VIEWER',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyActivator = 'SURVEY_ACTIVATOR',
    /** Can administer project and surveys */
    SurveyAdmin = 'SURVEY_ADMIN',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyAdministrator = 'SURVEY_ADMINISTRATOR',
    /** @deprecated Use SURVEY_ADMIN */
    SurveyPlanner = 'SURVEY_PLANNER',
    /** Full access */
    TeamAdmin = 'TEAM_ADMIN',
    /** Full access and legal owner of the team */
    TeamOwner = 'TEAM_OWNER',
}

export enum TeamMemberRoleResourceType {
    ImprovementCard = 'ImprovementCard',
    Portfolio = 'Portfolio',
    Project = 'Project',
    Team = 'Team',
}

export type TeamMemberTeamRole = TeamMemberRole & {
    readonly __typename?: 'TeamMemberTeamRole';
    readonly name: TeamMemberRoleName;
};

export type TextReplacement = {
    readonly __typename?: 'TextReplacement';
    readonly key: Scalars['String']['output'];
    readonly value: Scalars['String']['output'];
};

export type ToggleAllowReceiveSharedProjectsInput = {
    readonly allow: Scalars['Boolean']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type ToggleAllowReceiveSharedProjectsResponse = {
    readonly __typename?: 'ToggleAllowReceiveSharedProjectsResponse';
    readonly team?: Maybe<Team>;
};

export type ToggleTeamMemberNotificationInput = {
    readonly enabled: Scalars['Boolean']['input'];
    readonly portfolioId?: InputMaybe<Scalars['ID']['input']>;
    readonly teamId: Scalars['ID']['input'];
    readonly type: PQiTeamMemberNotificationType;
    readonly userId: Scalars['ID']['input'];
};

export type ToggleTeamMemberNotificationPayload = {
    readonly __typename?: 'ToggleTeamMemberNotificationPayload';
    readonly teamMember?: Maybe<TeamMember>;
};

export type ToggleTeamMemberProjectSurveyNotificationsInput = {
    readonly enabled: Scalars['Boolean']['input'];
    readonly projectId: Scalars['ID']['input'];
    readonly teamId: Scalars['ID']['input'];
    readonly userId: Scalars['ID']['input'];
};

export type ToggleTeamMemberProjectSurveyNotificationsPayload = {
    readonly __typename?: 'ToggleTeamMemberProjectSurveyNotificationsPayload';
    readonly project?: Maybe<Project>;
    readonly team?: Maybe<Team>;
};

export type TranslateQuestionAttributesInput = {
    readonly customImproveQuestion?: InputMaybe<Scalars['String']['input']>;
    readonly fullForm?: InputMaybe<Scalars['String']['input']>;
    readonly shortForm?: InputMaybe<Scalars['String']['input']>;
};

export type TranslateQuestionInput = {
    readonly attributes: TranslateQuestionAttributesInput;
    readonly questionId: Scalars['ID']['input'];
    readonly questionnaireId: Scalars['ID']['input'];
    readonly sourceLocale?: InputMaybe<Scalars['LanguageTag']['input']>;
    readonly targetLocale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type TranslateQuestionPayload = {
    readonly __typename?: 'TranslateQuestionPayload';
    readonly question?: Maybe<Question>;
};

export enum TypeOfInvoice {
    Electronic = 'Electronic',
    Email = 'Email',
    Paper = 'Paper',
}

export type UndoRemoveSelfAsRespondentInput = {
    readonly respondentId: Scalars['ID']['input'];
};

export type UndoRemoveSelfAsRespondentPayload = {
    readonly __typename?: 'UndoRemoveSelfAsRespondentPayload';
    readonly success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * You can unlock results from one survey, and/or specify a list of survey id's to
 * unlock multiple surveys in one request
 */
export type UnlockProjectSurveyResultsInput = {
    readonly surveyId?: InputMaybe<Scalars['ID']['input']>;
    readonly surveyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type UnlockProjectSurveyResultsPayload = {
    readonly __typename?: 'UnlockProjectSurveyResultsPayload';
    /** This is available if you specified a surveyId */
    readonly survey?: Maybe<ProjectSurvey>;
    /** This is available if you specified a list of surveyIds */
    readonly surveys?: Maybe<ReadonlyArray<ProjectSurvey>>;
};

export type UnmarkImprovementActivityAsCompletedInput = {
    readonly improvementActivityId: Scalars['ID']['input'];
};

export type UnmarkImprovementActivityAsCompletedResponse = {
    readonly __typename?: 'UnmarkImprovementActivityAsCompletedResponse';
    readonly improvementActivity?: Maybe<ImprovementActivity>;
};

export type UnshareProjectWithTeamInput = {
    readonly projectId: Scalars['ID']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type UnshareProjectWithTeamResponse = {
    readonly __typename?: 'UnshareProjectWithTeamResponse';
    readonly project: Project;
};

export type UpdateActiveDashboardSubscriptionInput = {
    readonly subscription: DashboardSubscriptionInput;
    readonly teamId: Scalars['ID']['input'];
};

export type UpdateActiveDashboardSubscriptionPayload = {
    readonly __typename?: 'UpdateActiveDashboardSubscriptionPayload';
    readonly team?: Maybe<Team>;
};

export type UpdateAreaOfImprovementInput = {
    readonly areaOfImprovementId: Scalars['ID']['input'];
    /** If given, the problem decription will be updated */
    readonly problemDescription?: InputMaybe<Scalars['String']['input']>;
    /** If given, the summary will be updated */
    readonly summary?: InputMaybe<Scalars['String']['input']>;
    /** If given, the tags will be updated */
    readonly tags?: InputMaybe<ReadonlyArray<AreaOfImprovementTagUnionInput>>;
};

export type UpdateAreaOfImprovementResponse = {
    readonly __typename?: 'UpdateAreaOfImprovementResponse';
    readonly areaOfImprovement?: Maybe<AreaOfImprovement>;
};

export type UpdateImprovementActivityInput = {
    readonly deadline?: InputMaybe<Scalars['DateTime']['input']>;
    readonly description?: InputMaybe<Scalars['String']['input']>;
    readonly goal?: InputMaybe<Scalars['String']['input']>;
    readonly improvementActivityId: Scalars['ID']['input'];
    readonly responsiblePerson: Scalars['ID']['input'];
    readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
    readonly summary: Scalars['String']['input'];
};

export type UpdateImprovementActivityResponse = {
    readonly __typename?: 'UpdateImprovementActivityResponse';
    readonly improvementActivity?: Maybe<ImprovementActivity>;
};

export type UpdateProjectSurveyTemplateInput = {
    readonly description: Scalars['String']['input'];
    readonly id: Scalars['ID']['input'];
    readonly name: Scalars['String']['input'];
    readonly questionFilters: ReadonlyArray<ProjectSurveyTemplateQuestionFilterInput>;
    readonly questionIds: ReadonlyArray<Scalars['String']['input']>;
    readonly teamId: Scalars['ID']['input'];
};

export type UpdateQuestionAttributesInput = {
    readonly hasCommentField?: InputMaybe<Scalars['Boolean']['input']>;
    readonly hasImproveQuestion?: InputMaybe<Scalars['Boolean']['input']>;
    readonly hasNoOpinion?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * If the question is a draft, you may specify "false" here to publish the question. You may not
     * specify "true" if the values previously was "false".
     *
     * We will likely remove this API later in favor of an explicit publishQuestion mutation
     */
    readonly isDraft?: InputMaybe<Scalars['Boolean']['input']>;
    /** Hide the question, it should no longer be used in surveys */
    readonly isHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQuestionInput = {
    readonly attributes: UpdateQuestionAttributesInput;
    /** Even though no localized attributes are updated, we need the locale to be able to return a question */
    readonly locale: Scalars['LanguageTag']['input'];
    /**
     * Optionally also update the localized attributes. Probably will remove this shortcut and force you to use
     * `translateQuestion` instead.
     */
    readonly localizedAttributes?: InputMaybe<UpdateQuestionLocalizedAttributesInput>;
    readonly questionId: Scalars['ID']['input'];
    readonly questionnaireId: Scalars['ID']['input'];
};

export type UpdateQuestionLocalizedAttributesInput = {
    readonly customImproveQuestion?: InputMaybe<Scalars['String']['input']>;
    readonly fullForm?: InputMaybe<Scalars['String']['input']>;
    readonly shortForm?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionPayload = {
    readonly __typename?: 'UpdateQuestionPayload';
    readonly question?: Maybe<Question>;
};

export type UpdateQuestionVisibilityConditionInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly questionnaireId: Scalars['ID']['input'];
    readonly visibilityCondition: VisibilityConditionInput;
};

export type UpdateVisibilityConditionInput = {
    /**
     * Optionally give the visibility condition a name. This is to be able to
     * identify this condition if you are using it with multiple questions
     */
    readonly name?: InputMaybe<Scalars['String']['input']>;
    readonly questionnaireId: Scalars['ID']['input'];
    readonly visibilityCondition: VisibilityConditionInput;
    readonly visibilityConditionId: Scalars['ID']['input'];
};

export type UpdateVisibilityConditionPayload = {
    readonly __typename?: 'UpdateVisibilityConditionPayload';
    readonly questionnaire?: Maybe<Questionnaire>;
    readonly visibilityCondition?: Maybe<VisibilityCondition>;
};

export type UpdateVisibilityConditionPayloadQuestionnaireArgs = {
    fallbackToDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
    locale?: InputMaybe<Scalars['LanguageTag']['input']>;
};

export type UseCustomPriceListInput = {
    readonly priceList: BudgetTieredPricingPriceListInput;
    readonly teamId: Scalars['ID']['input'];
};

export type UseCustomPriceListPayload = {
    readonly __typename?: 'UseCustomPriceListPayload';
    readonly team?: Maybe<Team>;
};

export type UseDefaultPriceListInput = {
    readonly currency: Scalars['String']['input'];
    readonly teamId: Scalars['ID']['input'];
};

export type UseDefaultPriceListPayload = {
    readonly __typename?: 'UseDefaultPriceListPayload';
    readonly team?: Maybe<Team>;
};

export type User = {
    readonly __typename?: 'User';
    readonly emailAddress: Scalars['String']['output'];
    readonly firstName: Scalars['String']['output'];
    readonly fullName: Scalars['String']['output'];
    readonly id: Scalars['ID']['output'];
    readonly lastName: Scalars['String']['output'];
    /** List the resource grants that is allowed for this user */
    readonly resourceGrants: ReadonlyArray<ResourceGrant>;
};

export type UserResourceGrantsArgs = {
    rootNode?: InputMaybe<Scalars['ID']['input']>;
    rootResource?: InputMaybe<Scalars['String']['input']>;
};

export type UserSettings = {
    readonly __typename?: 'UserSettings';
    /** Preferred locale used for comminucation */
    readonly preferredLocale?: Maybe<Scalars['LanguageTag']['output']>;
};

export type Viewer = {
    readonly __typename?: 'Viewer';
    readonly user?: Maybe<User>;
};

export type VisibilityCondition = VisibilityConditionInterface & {
    readonly __typename?: 'VisibilityCondition';
    readonly description?: Maybe<Scalars['String']['output']>;
    readonly expression: Scalars['String']['output'];
    readonly id: Scalars['ID']['output'];
    /** @deprecated Use description instead. Description is also localized, and may or may not exist */
    readonly name?: Maybe<Scalars['String']['output']>;
    readonly originalId: Scalars['String']['output'];
    readonly rules: ReadonlyArray<VisibilityConditionRule>;
};

export type VisibilityConditionAssignmentInput = {
    readonly Question?: InputMaybe<VisibilityConditionQuestionAssignmentInput>;
    readonly ResponseOption?: InputMaybe<VisibilityConditionResponseOptionAssignmentInput>;
    readonly type: VisibilityConditionAssignmentType;
};

export enum VisibilityConditionAssignmentType {
    Question = 'Question',
    ResponseOption = 'ResponseOption',
}

export type VisibilityConditionBooleanRule = VisibilityConditionRule & {
    readonly __typename?: 'VisibilityConditionBooleanRule';
    readonly ruleNumber: Scalars['Int']['output'];
    readonly type: VisibilityConditionRuleType;
    readonly value: Scalars['Boolean']['output'];
};

export type VisibilityConditionBooleanRuleInput = {
    readonly value: Scalars['Boolean']['input'];
};

export type VisibilityConditionInput = {
    /**
     * An expression is a logical expression with 1-based rule numbers.
     *
     * Example:
     * 1 and (2 or 3 or 4) and !5
     *
     * The question is visible if
     * * rule 1 evaluates to true
     * * and rule 2, 3 or 4 evaluates to true
     * * and rule 5 evaluates to false
     *
     * If you choose to NOT provide an expression, the default is that if ANY rules
     * matches, the condition is fulfilled
     */
    readonly expression?: InputMaybe<Scalars['String']['input']>;
    readonly rules: ReadonlyArray<VisibilityConditionRuleInput>;
};

export type VisibilityConditionInterface = {
    readonly expression: Scalars['String']['output'];
    readonly rules: ReadonlyArray<VisibilityConditionRule>;
};

export type VisibilityConditionQuestionAssignmentInput = {
    readonly questionId: Scalars['ID']['input'];
};

export type VisibilityConditionResponseOptionAssignmentInput = {
    readonly responseOptionValue: Scalars['Int']['input'];
    readonly responseScaleId: Scalars['ID']['input'];
};

export type VisibilityConditionResponseOptionTagRule =
    VisibilityConditionRule & {
        readonly __typename?: 'VisibilityConditionResponseOptionTagRule';
        readonly originalQuestionId: Scalars['String']['output'];
        readonly questionId: Scalars['ID']['output'];
        readonly responseOptionTag: Scalars['String']['output'];
        readonly ruleNumber: Scalars['Int']['output'];
        readonly type: VisibilityConditionRuleType;
    };

export type VisibilityConditionResponseOptionTagRuleInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly responseOptionTag: Scalars['String']['input'];
};

export type VisibilityConditionResponseOptionValueFirstTimeRule =
    VisibilityConditionRule & {
        readonly __typename?: 'VisibilityConditionResponseOptionValueFirstTimeRule';
        readonly originalQuestionId: Scalars['String']['output'];
        readonly questionId: Scalars['ID']['output'];
        readonly responseOptionValue: Scalars['Int']['output'];
        readonly ruleNumber: Scalars['Int']['output'];
        readonly type: VisibilityConditionRuleType;
    };

export type VisibilityConditionResponseOptionValueRule =
    VisibilityConditionRule & {
        readonly __typename?: 'VisibilityConditionResponseOptionValueRule';
        readonly originalQuestionId: Scalars['String']['output'];
        readonly questionId: Scalars['ID']['output'];
        readonly responseOptionValue: Scalars['Int']['output'];
        readonly ruleNumber: Scalars['Int']['output'];
        readonly type: VisibilityConditionRuleType;
    };

export type VisibilityConditionResponseOptionValueRuleInput = {
    readonly questionId: Scalars['ID']['input'];
    readonly responseOptionValue: Scalars['Int']['input'];
};

export type VisibilityConditionRule = {
    readonly ruleNumber: Scalars['Int']['output'];
    readonly type: VisibilityConditionRuleType;
};

export type VisibilityConditionRuleInput = {
    readonly Boolean?: InputMaybe<VisibilityConditionBooleanRuleInput>;
    readonly ResponseOptionTag?: InputMaybe<VisibilityConditionResponseOptionTagRuleInput>;
    readonly ResponseOptionValue?: InputMaybe<VisibilityConditionResponseOptionValueRuleInput>;
    readonly ResponseOptionValueFirstTime?: InputMaybe<VisibilityConditionResponseOptionValueRuleInput>;
};

export enum VisibilityConditionRuleType {
    Boolean = 'Boolean',
    ResponseOptionTag = 'ResponseOptionTag',
    ResponseOptionValue = 'ResponseOptionValue',
    ResponseOptionValueFirstTime = 'ResponseOptionValueFirstTime',
}
